
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5dNRq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $dAbO5 = parcelRequire("dAbO5");

var $1VNax = parcelRequire("1VNax");

var $6r7Ix = parcelRequire("6r7Ix");

var $hjUk0 = parcelRequire("hjUk0");

var $6UUyu = parcelRequire("6UUyu");

var $4cOi8 = parcelRequire("4cOi8");

var $jD7cj = parcelRequire("jD7cj");

var $hECbK = parcelRequire("hECbK");

var $1m9A2 = parcelRequire("1m9A2");

var $3VS69 = parcelRequire("3VS69");

var $g3LxX = parcelRequire("g3LxX");

var $3v7tz = parcelRequire("3v7tz");

var $fOKpq = parcelRequire("fOKpq");


var $kcoxM = parcelRequire("kcoxM");


var $e51Sk = parcelRequire("e51Sk");




var $5un3P = parcelRequire("5un3P");


var $4LKV2 = parcelRequire("4LKV2");

var $e602f7fca58afed2$exports = {};
$e602f7fca58afed2$exports = new URL("CardsV1Preview.84b1fee2.svg", import.meta.url).toString();

var $69017605bdf01986$exports = {};
$69017605bdf01986$exports = new URL("CardsV1PreviewDark.4e29b6b0.svg", import.meta.url).toString();

var $91cbe0ea0a5fc348$exports = {};
$91cbe0ea0a5fc348$exports = new URL("CardsV2Preview.35d6ee74.svg", import.meta.url).toString();

var $2b814e09ffd55c03$exports = {};
$2b814e09ffd55c03$exports = new URL("CardsV2PreviewDark.9d7cd6d3.svg", import.meta.url).toString();



var $cKAxI = parcelRequire("cKAxI");




parcelRequire("42omo");


var $2oKNO = parcelRequire("2oKNO");


var $izxBd = parcelRequire("izxBd");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");









var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");




var $5n7dr = parcelRequire("5n7dr");

var $fQWPs = parcelRequire("fQWPs");

var $7Ux0V = parcelRequire("7Ux0V");

var $1u5CA = parcelRequire("1u5CA");


var $7XNwX = parcelRequire("7XNwX");















var $bfgIy = parcelRequire("bfgIy");







var $7rus4 = parcelRequire("7rus4");





var $cgtv4 = parcelRequire("cgtv4");

const $b8e7ebc5c17b1223$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    segmentationTargetGroupsLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-groups-text-label",
        defaultMessage: "Target groups"
    },
    segmentationTargetGroupsLabelV2: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-groups-text-label.v2",
        defaultMessage: "Target audience groups"
    }
});


const $369b00ffe50c9c44$var$updatedStyles = {
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    borderRadius: "var(--ds-radius-small, 4px)"
};
const $369b00ffe50c9c44$export$2261f4215d6c3d25 = ({ targetGroupsIds: targetGroupsIds, onGroupSelected: onGroupSelected, showUpdatedStyles: showUpdatedStyles = false, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [selectedGroups, setSelectedGroups] = (0, $42omo.useState)([]);
    const initialGroupIds = (0, $42omo.useRef)(targetGroupsIds || []);
    const initialGroups = (0, $42omo.useRef)([]);
    const [nextCursor, setNextCursor] = (0, $42omo.useState)(undefined);
    const { useSegmentationTargetGroups: useSegmentationTargetGroups, cloudId: cloudId, orgId: orgId } = (0, $fOKpq.useProductDependencies)();
    const { data: data, loading: loading, errorComponent: errorComponent } = useSegmentationTargetGroups?.({
        nextCursor: nextCursor,
        initialGroupIds: initialGroupIds.current || []
    }) || {};
    (0, $42omo.useEffect)(()=>{
        const groups = [];
        const groupIds = initialGroupIds.current;
        for (const id of groupIds){
            const group = data?.groups?.nodes?.find((node)=>node?.id === id);
            if (group && group.id && group.name) groups.push({
                id: group.id,
                name: group.name,
                type: 'group'
            });
        }
        const newGroups = [
            ...initialGroups.current,
            ...groups
        ];
        initialGroups.current = newGroups;
        if (data?.groups?.pageInfo?.hasNextPage && newGroups.length < groupIds.length) setNextCursor(data.groups.pageInfo.endCursor);
        else setSelectedGroups(newGroups);
    }, [
        data
    ]);
    const handleSelectOnChange = (0, $42omo.useCallback)((values)=>{
        const groups = values ? values : [];
        setSelectedGroups(groups);
        onGroupSelected(groups.length > 0 ? groups.map((group)=>group.id) : undefined);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: 'hubSegmentationTargetGroupsDropdown',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onGroupSelected,
        source
    ]);
    const filterSystemGroups = (options)=>{
        const HIDDEN_GROUP_NAME = 'system-administrators';
        return options.filter((option)=>option.name !== HIDDEN_GROUP_NAME);
    };
    return errorComponent ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: errorComponent
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                htmlFor: "card-segmentation-target-groups-selector",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: showUpdatedStyles ? 'medium' : 'small',
                    weight: showUpdatedStyles ? 'regular' : 'bold',
                    color: showUpdatedStyles ? 'color.text' : 'inherit',
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...showUpdatedStyles ? (0, $b8e7ebc5c17b1223$export$defe85febe8b728c).segmentationTargetGroupsLabelV2 : (0, $b8e7ebc5c17b1223$export$defe85febe8b728c).segmentationTargetGroupsLabel
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rus4.default), {
                    filterOptions: filterSystemGroups,
                    isLoading: loading,
                    fieldId: "card-segmentation-target-groups-selector",
                    inputId: "card-segmentation-target-groups-selector",
                    siteId: cloudId,
                    orgId: orgId,
                    debounceTime: 400,
                    productKey: "confluence",
                    includeUsers: false,
                    includeGroups: true,
                    isMulti: true,
                    width: "100%",
                    value: selectedGroups,
                    placeholder: "",
                    addMoreMessage: "",
                    onChange: handleSelectOnChange,
                    noOptionsMessage: ()=>null,
                    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                    styles: {
                        valueContainer: (base)=>({
                                ...base,
                                minHeight: showUpdatedStyles ? 'auto' : '56px',
                                alignItems: 'start'
                            }),
                        multiValue: (provided)=>({
                                ...provided,
                                ...showUpdatedStyles ? $369b00ffe50c9c44$var$updatedStyles : {},
                                div: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }
                            })
                    }
                })
            })
        ]
    });
};


var $7lwhH = parcelRequire("7lwhH");









/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $jSnXV = parcelRequire("jSnXV");

var $448e363c019d94a8$exports = {};

var $9vwa5 = parcelRequire("9vwa5");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $448e363c019d94a8$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $448e363c019d94a8$var$isBoolean(value) {
    return value === true || value === false || $6eZU2(value) && $9vwa5(value) == $448e363c019d94a8$var$boolTag;
}
$448e363c019d94a8$exports = $448e363c019d94a8$var$isBoolean;












var $k00oi = parcelRequire("k00oi");












var $9EtP6 = parcelRequire("9EtP6");


var $4noo5 = parcelRequire("4noo5");


var $kAaxz = parcelRequire("kAaxz");


var $2Rith = parcelRequire("2Rith");


var $dOOm2 = parcelRequire("dOOm2");

var $au4KV = parcelRequire("au4KV");




/**
 * @generated SignedSource<<01426a62df798db5e32c65abbf2e6586>>
 * @relayHash 0481678a27915107a3ab2adb52c2e123
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b974990a74bfc372f1062b5fb7128b96b7b2efa14d0d4623371ba38a9319d49a
const $eeccd6862873a2b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "spaceId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "homepageId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "aiDescriptionButtonWrapperQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "aiDescriptionButtonWrapperQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b974990a74bfc372f1062b5fb7128b96b7b2efa14d0d4623371ba38a9319d49a",
            "metadata": {},
            "name": "aiDescriptionButtonWrapperQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$eeccd6862873a2b1$var$node.hash = "162796af29855f994bf05873d1c21a58";
var $eeccd6862873a2b1$export$2e2bcd8739ae039 = $eeccd6862873a2b1$var$node;






var $irOoi = parcelRequire("irOoi");


var $3j1mV = parcelRequire("3j1mV");


var $gWF6I = parcelRequire("gWF6I");



















var $ccHMk = parcelRequire("ccHMk");


var $3Mg7y = parcelRequire("3Mg7y");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");







var $5NXxU = parcelRequire("5NXxU");


var $iIEgX = parcelRequire("iIEgX");

var $aXpOY = parcelRequire("aXpOY");


var $cPtvM = parcelRequire("cPtvM");




function $74b588e469188e6a$export$6983f0e8c17d512d(config, onStateChange) {
    const refetchId = (0, $42omo.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $aXpOY.useStatefulObservableLazyEffect)((0, $cPtvM.convoAIStreamingEffect), (0, $kAaxz.getDefaultConvoAIStreamingState)());
    (0, $iIEgX.useObservableEffect)((input$)=>input$.pipe((0, $5NXxU.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const fetch = (0, $42omo.useCallback)((request)=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $kAaxz.getDefaultConvoAIStreamingState)()
        });
    }, [
        config,
        setState
    ]);
    return [
        state,
        fetch
    ];
}



var $fYQcF = parcelRequire("fYQcF");







const $4fdde48d08aec6f4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    suggestDescriptionLabel: {
        id: "company-hub.company-hub-common.link-cards.description.button.suggest-description.label",
        defaultMessage: "Suggest Description"
    }
});


const $6f86fd829864d882$var$buttonContainerStyles = (0, $ecnYn.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    width: 'fit-content',
    marginTop: 'space.075',
    marginBottom: 'space.075',
    borderRadius: 'radius.large'
});
const $6f86fd829864d882$var$buildSummaryRequest = ({ contentAri: contentAri, locale: locale })=>{
    return [
        {
            ai_feature_input: {
                content_ari: contentAri,
                locale: locale,
                character_max: 95
            }
        },
        {
            apiPath: 'v2/ai-feature/confluence-concise-summary',
            delayChunkUpdate: {
                gap: 10,
                time: 20
            },
            headers: {
                'x-experience-id': 'confluence-concise-summary',
                'x-product': 'confluence'
            }
        }
    ];
};
const $6f86fd829864d882$export$5a36a527b7753afd = ({ pageAri: pageAri, confluencePageId: confluencePageId, isAILoading: isAILoading, setIsAILoading: setIsAILoading, setAIError: setAIError, setAIDescriptionContent: setAIDescriptionContent, setAIResponseState: setAIResponseState, analyticsSource: analyticsSource })=>{
    const { aiDescriptionExperienceTracker: aiDescriptionExperienceTracker } = (0, $fOKpq.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { locale: locale } = (0, $8C5kA.default)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError } = (0, $fYQcF.useAIEventsInstrumentation)();
    const onStateChange = (0, $42omo.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $kAaxz.ConvoAIResponseState).Error:
                if (state.error) {
                    const { status_code: aiErrorCode, message_template: aiErrorMessage } = state.error.message;
                    trackAIResultError({
                        aiErrorCode: aiErrorCode,
                        aiErrorMessage: aiErrorMessage
                    });
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                if (state.content) trackAIResultView();
                break;
            default:
                break;
        }
    }, [
        trackAIResultError,
        trackAIResultView
    ]);
    const [request, config] = (0, $42omo.useMemo)(()=>$6f86fd829864d882$var$buildSummaryRequest({
            contentAri: pageAri,
            locale: locale
        }), [
        locale,
        pageAri
    ]);
    const [{ content: content, responseState: responseState, error: error }, fetchAI] = (0, $74b588e469188e6a$export$6983f0e8c17d512d)(config, onStateChange);
    const startAIDescription = (0, $42omo.useCallback)(()=>{
        trackAIInteractionInit();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiDescription',
                source: analyticsSource
            }
        }).fire();
        aiDescriptionExperienceTracker?.start({
            analyticsSource: analyticsSource,
            confluencePageId: confluencePageId
        });
        setIsAILoading(true);
        fetchAI(request);
    }, [
        fetchAI,
        request,
        trackAIInteractionInit,
        confluencePageId,
        createAnalyticsEvent,
        aiDescriptionExperienceTracker,
        analyticsSource,
        setIsAILoading
    ]);
    (0, $42omo.useEffect)(()=>{
        setAIResponseState(responseState);
        setAIDescriptionContent(content);
        setAIError(error);
    }, [
        responseState,
        content,
        error,
        setAIResponseState,
        setAIDescriptionContent,
        setAIError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $6f86fd829864d882$var$buttonContainerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: startAIDescription,
            isDisabled: isAILoading,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $4fdde48d08aec6f4$export$defe85febe8b728c).suggestDescriptionLabel
            })
        })
    });
};


// If linkResourceType is 'space', then it's a Space Overview Page, which is type "page".
// If linkResourceType is a 'blog', then we update to "blogpost" for pageAri
const $d78df4d96d7aa87e$var$getContentTypeForPageAri = (linkResourceType)=>{
    switch(linkResourceType){
        case 'blog':
            return 'blogpost';
        case 'space':
            return 'page';
        default:
            return linkResourceType;
    }
};
const $d78df4d96d7aa87e$export$4e2e1778ae07237 = ({ confluencePageId: confluencePageId, linkResourceType: linkResourceType, isAILoading: isAILoading, setIsAILoading: setIsAILoading, setAIError: setAIError, setAIDescriptionContent: setAIDescriptionContent, setAIResponseState: setAIResponseState, analyticsSource: analyticsSource })=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [queriedHomepageId, setQueriedHomepageId] = (0, $42omo.useState)('');
    const [errorComponent, setErrorComponent] = (0, $42omo.useState)(null);
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled, errorDisplayComponent: errorDisplayComponent } = (0, $fOKpq.useProductDependencies)();
    const environment = (0, $gWF6I.useRelayEnvironmentProvider)().getEnvironment({});
    const querySpaceOverviewHomepageId = (0, $42omo.useCallback)(async ()=>{
        // If it's not a space overview page, we don't need to fetch the homepageId
        if (linkResourceType !== 'space') {
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const spaceOverviewData = await (0, $irOoi.fetchQuery)(environment, (0, $eeccd6862873a2b1$export$2e2bcd8739ae039), {
                spaceId: confluencePageId
            }).toPromise();
            setQueriedHomepageId(spaceOverviewData?.space?.homepageId ?? '');
        } catch (error) {
            if (errorDisplayComponent) {
                const ErrorComponent = errorDisplayComponent;
                setErrorComponent(/*#__PURE__*/ (0, $l998X.jsx)(ErrorComponent, {
                    error: error
                }));
            }
        } finally{
            setLoading(false);
        }
    }, [
        linkResourceType,
        confluencePageId,
        environment,
        errorDisplayComponent
    ]);
    (0, $42omo.useEffect)(()=>{
        querySpaceOverviewHomepageId();
    }, [
        querySpaceOverviewHomepageId
    ]);
    const contentType = $d78df4d96d7aa87e$var$getContentTypeForPageAri(linkResourceType);
    const isPageOrBlog = contentType === 'page' || contentType === 'blogpost';
    const pageId = linkResourceType === 'space' ? queriedHomepageId : confluencePageId;
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, pageId, contentType);
    if (errorComponent) return errorComponent;
    const shouldRenderAIButton = isAdminHubAIEnabled && !loading && isPageOrBlog;
    return shouldRenderAIButton && pageAri && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f86fd829864d882$export$5a36a527b7753afd), {
        pageAri: pageAri,
        confluencePageId: confluencePageId,
        isAILoading: isAILoading,
        setIsAILoading: setIsAILoading,
        setAIError: setAIError,
        setAIDescriptionContent: setAIDescriptionContent,
        setAIResponseState: setAIResponseState,
        analyticsSource: analyticsSource
    });
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $dE1p6 = parcelRequire("dE1p6");





var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");


var $auNCB = parcelRequire("auNCB");






var $93WqG = parcelRequire("93WqG");






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Copied from @confluence/ai-common/ui AIErrorText and its wrapper AIPageErrorText



parcelRequire("42omo");
















const $65922703d742dad9$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    generalError: {
        id: "company-hub-common.ai.error.common-error.general-error",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Read more <a>in our support documentation</a>."
    },
    notEnoughContent: {
        id: "company-hub-common.ai.error.common-error.not-enough-content",
        defaultMessage: "There isn\u2019t enough content here to summarize. Try again when more content has been added."
    },
    rateLimit: {
        id: "company-hub-common.ai.error.common-error.rate-limit",
        defaultMessage: "Excessive use has been detected with Atlassian Intelligence. Try again later. Read more <a>in our support documentation</a>."
    },
    tooMuchContent: {
        id: "company-hub-common.ai.error.page-error.too-much-content",
        defaultMessage: "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is too much content to summarize."
    },
    aupViolation: {
        id: "company-hub-common.ai.error.page-error.aup-violation",
        defaultMessage: "Your content might not comply with our Acceptable Use Policy. Please review and refer to our <a>Acceptable Use Policy</a> if needed."
    }
});


var $4e0ae92bc1b25419$export$987753f1dd27cb69 = /*#__PURE__*/ function(AIGQLErrors) {
    AIGQLErrors["NOT_ENOUGH_CONTENT"] = "NOT_ENOUGH_CONTENT";
    AIGQLErrors["TOO_MUCH_CONTENT"] = "TOO_MUCH_CONTENT";
    AIGQLErrors["TOO_MANY_REQUEST"] = "RATE_LIMIT";
    AIGQLErrors["AUP_VIOLATION"] = "AUP_VIOLATION";
    AIGQLErrors["GENERAL_ERROR"] = "GENERAL_ERROR";
    return AIGQLErrors;
}({});
var $4e0ae92bc1b25419$export$939494aa166c4495 = /*#__PURE__*/ function(AIErrorLinkType) {
    AIErrorLinkType["Troubleshooting"] = "Troubleshooting";
    AIErrorLinkType["RateLimit"] = "RateLimit";
    AIErrorLinkType["AupViolation"] = "AupViolation";
    return AIErrorLinkType;
}({});
var $4e0ae92bc1b25419$export$249411c33615135b = /*#__PURE__*/ function(ErrorMessageKeys) {
    ErrorMessageKeys["GENERAL_ERROR"] = "generalError";
    ErrorMessageKeys["NOT_ENOUGH_CONTENT"] = "notEnoughContent";
    ErrorMessageKeys["TOO_MUCH_CONTENT"] = "tooMuchContent";
    ErrorMessageKeys["RATE_LIMIT"] = "rateLimit";
    ErrorMessageKeys["AUP_VIOLATION"] = "aupViolation";
    return ErrorMessageKeys;
}({});
var $4e0ae92bc1b25419$export$4a95903507aabb8b = /*#__PURE__*/ function(ConvoAIErrorMessageMap) {
    ConvoAIErrorMessageMap["RATE_LIMIT"] = "rateLimit";
    ConvoAIErrorMessageMap["ANSWER_UNAVAILABLE_FOR_CONTENT"] = "notEnoughContent";
    ConvoAIErrorMessageMap["ACCEPTABLE_USE_VIOLATIONS"] = "aupViolation";
    ConvoAIErrorMessageMap["BAD_REQUEST"] = "generalError";
    ConvoAIErrorMessageMap["UNEXPECTED"] = "generalError";
    ConvoAIErrorMessageMap["TIMEOUT"] = "generalError";
    ConvoAIErrorMessageMap["NOT_ENOUGH_CONTENT_ERROR"] = "notEnoughContent";
    return ConvoAIErrorMessageMap;
}({});
var $4e0ae92bc1b25419$var$BaseErrorMessageMap = /*#__PURE__*/ function(BaseErrorMessageMap) {
    BaseErrorMessageMap["GENERAL_ERROR"] = "generalError";
    BaseErrorMessageMap["NETWORK_ERROR"] = "generalError";
    BaseErrorMessageMap["NO_ANSWER"] = "generalError";
    BaseErrorMessageMap["NO_AGENT"] = "generalError";
    BaseErrorMessageMap["PLUGIN_ERRORED"] = "generalError";
    BaseErrorMessageMap["AI_DISABLED"] = "generalError";
    BaseErrorMessageMap["OPENAI_RATE_LIMIT"] = "rateLimit";
    BaseErrorMessageMap["AUP_VIOLATION"] = "aupViolation";
    BaseErrorMessageMap["NOT_ENOUGH_CONTENT"] = "notEnoughContent";
    // typo comes from the backend
    // https://bitbucket.org/atlassian/assistance-service/src/02087c3b6569f042ec338e08e8e0e152c4563dad/src/schema/message_publisher.py#lines-74
    BaseErrorMessageMap["ASWER_UNAVAILABLE_FOR_CONTENT"] = "notEnoughContent";
    BaseErrorMessageMap["TOO_MUCH_CONTENT"] = "tooMuchContent";
    BaseErrorMessageMap["NOT_FOUND"] = "generalError";
    BaseErrorMessageMap["INTERNAL_SERVER_ERROR"] = "generalError";
    return BaseErrorMessageMap;
}($4e0ae92bc1b25419$var$BaseErrorMessageMap || {});
const $4e0ae92bc1b25419$export$71adb9ac7cae993c = {
    ...$4e0ae92bc1b25419$export$4a95903507aabb8b,
    ...$4e0ae92bc1b25419$var$BaseErrorMessageMap
};
var $4e0ae92bc1b25419$export$19d76c6edad3e4d4 = /*#__PURE__*/ function(ErrorMessageKeyErrorLinkMap) {
    ErrorMessageKeyErrorLinkMap["generalError"] = "Troubleshooting";
    ErrorMessageKeyErrorLinkMap["rateLimit"] = "RateLimit";
    ErrorMessageKeyErrorLinkMap["aupViolation"] = "AupViolation";
    ErrorMessageKeyErrorLinkMap["notEnoughContent"] = "Troubleshooting";
    ErrorMessageKeyErrorLinkMap["tooMuchContent"] = "Troubleshooting";
    return ErrorMessageKeyErrorLinkMap;
}({});


const $933fd3b1ff2c09f3$var$textStyles = {
    root: "_syaz1rpy"
};
const $933fd3b1ff2c09f3$export$6c1f59b2f89fe4f1 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $933fd3b1ff2c09f3$export$b4fefae0b724683f = 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/';
const $933fd3b1ff2c09f3$export$2876254020381b5e = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $933fd3b1ff2c09f3$var$LINK_MAP = {
    [(0, $4e0ae92bc1b25419$export$939494aa166c4495).RateLimit]: $933fd3b1ff2c09f3$export$b4fefae0b724683f,
    [(0, $4e0ae92bc1b25419$export$939494aa166c4495).AupViolation]: $933fd3b1ff2c09f3$export$2876254020381b5e,
    [(0, $4e0ae92bc1b25419$export$939494aa166c4495).Troubleshooting]: $933fd3b1ff2c09f3$export$6c1f59b2f89fe4f1
};
const $933fd3b1ff2c09f3$export$68b33c6c9404cf85 = ({ errorType: errorType, source: source, analyticsAttributes: analyticsAttributes, xcss: xcss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const errorMessageKey = (0, $4e0ae92bc1b25419$export$71adb9ac7cae993c)[errorType];
    const errorMessage = (0, $65922703d742dad9$export$defe85febe8b728c)[errorMessageKey];
    const linkType = (0, $4e0ae92bc1b25419$export$939494aa166c4495)[(0, $4e0ae92bc1b25419$export$19d76c6edad3e4d4)[errorMessageKey]];
    const onDocsLinkClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: `atlassianIntelligence${linkType}DocsLink`,
                ...analyticsAttributes ? {
                    attributes: analyticsAttributes
                } : {}
            }
        }).fire();
    };
    // This is safe for messages without link replacements also.
    // formatMessage ignores replacements when none exist in the string
    const resolvedMessage = formatMessage(errorMessage, {
        a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: $933fd3b1ff2c09f3$var$LINK_MAP[linkType],
                target: "_blank",
                onClick: onDocsLinkClicked,
                children: chunks
            })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: xcss || $933fd3b1ff2c09f3$var$textStyles.root,
        ...props,
        children: resolvedMessage
    });
};






const $32bc6568d650a9b1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    aIDisclaimer: {
        id: "company-hub.company-hub-common.link-cards.description.ai-disclaimer",
        defaultMessage: "Content quality may vary"
    },
    aIAttributionLabel: {
        id: "company-hub.company-hub-common.link-cards.description.link.label.ai",
        defaultMessage: "Learn more about Atlassian AI"
    }
});


const $36f4f0d8277b2fba$var$styles = {
    anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1rpy _10531rpy",
    successContainer: "_19pk1b66",
    errorText: "_syaz1tmw",
    errorContainer: "_syaz1tmw _19pk1b66"
};
const $36f4f0d8277b2fba$var$ErrorMessage = ({ errorType: errorType, analyticsSource: analyticsSource })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        xcss: $36f4f0d8277b2fba$var$styles.errorContainer,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                paddingBlockStart: "space.050",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    label: "",
                    LEGACY_size: "small",
                    color: "var(--ds-icon-accent-red)"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $933fd3b1ff2c09f3$export$68b33c6c9404cf85), {
                errorType: errorType,
                source: analyticsSource,
                xcss: $36f4f0d8277b2fba$var$styles.errorText
            })
        ]
    });
const $36f4f0d8277b2fba$export$108645d938839241 = [
    (0, $4e0ae92bc1b25419$export$4a95903507aabb8b).NOT_ENOUGH_CONTENT_ERROR,
    (0, $4e0ae92bc1b25419$export$4a95903507aabb8b).ANSWER_UNAVAILABLE_FOR_CONTENT,
    (0, $4e0ae92bc1b25419$export$4a95903507aabb8b).ACCEPTABLE_USE_VIOLATIONS
];
const $36f4f0d8277b2fba$export$f1233e533b345659 = ({ responseState: responseState, error: error, analyticsSource: analyticsSource })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { aiDescriptionExperienceTracker: aiDescriptionExperienceTracker, errorDisplayComponent: errorDisplayComponent } = (0, $fOKpq.useProductDependencies)();
    const { markErrorAsHandled: markErrorAsHandled } = (0, $fOKpq.useProductDependencies)();
    const [showError, setShowError] = (0, $42omo.useState)();
    const ErrorDisplay = errorDisplayComponent || (0, $42omo.Fragment);
    (0, $42omo.useEffect)(()=>{
        if (responseState === (0, $kAaxz.ConvoAIResponseState).Error) {
            setShowError(true);
            const timer = setTimeout(()=>{
                setShowError(false);
            }, 8000);
            return ()=>clearTimeout(timer);
        }
    }, [
        responseState
    ]);
    switch(responseState){
        case (0, $kAaxz.ConvoAIResponseState).Error:
            if (showError) {
                const errorType = error?.message.message_template || (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED;
                const mappedErrorMessage = errorType in (0, $4e0ae92bc1b25419$export$4a95903507aabb8b) ? (0, $4e0ae92bc1b25419$export$4a95903507aabb8b)[errorType] : (0, $4e0ae92bc1b25419$export$4a95903507aabb8b).UNEXPECTED;
                const isExpectedError = $36f4f0d8277b2fba$export$108645d938839241.includes(mappedErrorMessage);
                if (isExpectedError) {
                    markErrorAsHandled?.(new Error(error?.message.content));
                    aiDescriptionExperienceTracker?.abort?.({
                        reason: `Cannot generate summary due to ${errorType}`
                    });
                } else aiDescriptionExperienceTracker?.stopOnError({
                    error: new Error(error?.message.content)
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: isExpectedError ? /*#__PURE__*/ (0, $l998X.jsx)($36f4f0d8277b2fba$var$ErrorMessage, {
                        errorType: errorType,
                        analyticsSource: analyticsSource
                    }) : /*#__PURE__*/ (0, $l998X.jsx)(ErrorDisplay, {
                        error: new Error(error?.message.content),
                        children: /*#__PURE__*/ (0, $l998X.jsx)($36f4f0d8277b2fba$var$ErrorMessage, {
                            errorType: errorType,
                            analyticsSource: analyticsSource
                        })
                    })
                });
            }
            return null;
        case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
            aiDescriptionExperienceTracker?.succeed();
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $36f4f0d8277b2fba$var$styles.successContainer,
                spread: "space-between",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                                label: "",
                                color: "var(--ds-icon-subtle, #505258)",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                                href: "https://www.atlassian.com/trust/atlassian-intelligence",
                                target: "_blank",
                                xcss: $36f4f0d8277b2fba$var$styles.anchor,
                                children: formatMessage((0, $32bc6568d650a9b1$export$defe85febe8b728c).aIDisclaimer)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
                        spacing: "compact",
                        href: "https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/",
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))),
                        label: formatMessage((0, $32bc6568d650a9b1$export$defe85febe8b728c).aIAttributionLabel),
                        target: "_blank"
                    })
                ]
            });
        default:
            break;
    }
};



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 













var $1qfLF = parcelRequire("1qfLF");





var $ghftu = parcelRequire("ghftu");


var $aRCWA = parcelRequire("aRCWA");


var $lGgRw = parcelRequire("lGgRw");












var $4OyNx = parcelRequire("4OyNx");

var $lhvsH = parcelRequire("lhvsH");







var $jCIc5 = parcelRequire("jCIc5");

const $7edf9929df4d5c99$export$2a373433aec2c21b = 'labelColor';





const $acd9e94768b0cef1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    labelButtonTitle: {
        id: "company-hub.company-hub-common.config-panel.content.label-button.title",
        defaultMessage: "Label"
    },
    labelPopupTitle: {
        id: "company-hub.company-hub-common.config-panel.content.label-button.popup.title",
        defaultMessage: "Label"
    },
    hideLabelButtonText: {
        id: "company-hub.company-hub-common.config-panel.content.label-button.popup.hide-label-button.text",
        defaultMessage: "Hide label"
    }
});


const $2b0b43c79c6ed957$var$styles = {
    labelPopupContainer: "_1bsb1osq _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp"
};
const $2b0b43c79c6ed957$export$239fbcd864262455 = ({ labelId: labelId, labelValue: labelValue, handleLabelChange: handleLabelChange, isLabelHiddenValue: isLabelHiddenValue, handleIsLabelHiddenChange: handleIsLabelHiddenChange, labelColorValue: labelColorValue, handleLabelColorChange: handleLabelColorChange })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const [openPopup, setOpenPopup] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const customColorRef = (0, $42omo.useRef)();
    const defaultLabelColor = (0, $lhvsH.DEFAULT_GRAY_COLOR);
    const handleChangeTextField = (0, $42omo.useCallback)((event)=>{
        handleLabelChange(event.currentTarget.value.toUpperCase());
    }, [
        handleLabelChange
    ]);
    const handleChangeColorPicker = (0, $42omo.useCallback)((color)=>{
        handleLabelColorChange(color);
    }, [
        handleLabelColorChange
    ]);
    const handleHideToggle = ()=>{
        handleIsLabelHiddenChange(!isLabelHiddenValue);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        isOpen: openPopup,
        onClose: ()=>setOpenPopup(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.200",
                xcss: $2b0b43c79c6ed957$var$styles.labelPopupContainer,
                testId: "label-popup-content",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                                htmlFor: labelId,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jCIc5.PanelSubheader), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $acd9e94768b0cef1$export$defe85febe8b728c).labelPopupTitle
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    isTooltipDisabled: false,
                                    isSelected: isLabelHiddenValue,
                                    spacing: "compact",
                                    appearance: "subtle",
                                    label: formatMessage((0, $acd9e94768b0cef1$export$defe85febe8b728c).hideLabelButtonText),
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRCWA))),
                                    onClick: handleHideToggle
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                        id: labelId,
                        value: labelValue?.toUpperCase(),
                        onChange: handleChangeTextField
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4OyNx.CuratedPalette), {
                        analyticsSource: (0, $7edf9929df4d5c99$export$2a373433aec2c21b),
                        builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                        customColorRef: customColorRef,
                        onChange: handleChangeColorPicker,
                        value: labelColorValue || defaultLabelColor
                    })
                ]
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                ...triggerProps,
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: ()=>setOpenPopup(!openPopup),
                isSelected: openPopup,
                children: formatMessage((0, $acd9e94768b0cef1$export$defe85febe8b728c).labelButtonTitle)
            })
    });
};


var $8jjEv = parcelRequire("8jjEv");



var $d0hoS = parcelRequire("d0hoS");




var $iqWjJ = parcelRequire("iqWjJ");















const $6f290cfa855699b1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    linkFieldLabel: {
        id: "company-hub.cards-extension.config-panel.link.field.label",
        defaultMessage: "Link"
    },
    titleFieldLabel: {
        id: "company-hub.cards-extension.title.field.label",
        defaultMessage: "Title"
    },
    recommendedFieldLabel: {
        id: "company-hub.cards-extension.recommended.field.label",
        defaultMessage: "(Recommended)"
    },
    descriptionFieldLabel: {
        id: "company-hub.cards-extension.description.field.label",
        defaultMessage: "Description"
    }
});


const $c9383a3ed04c2259$var$styles = {
    aiLoadingTextContainer: "_11c8dcr7 _syazazsu",
    fieldWrapperStyles: "_19pkpxbi"
};
const $c9383a3ed04c2259$var$debouncedParametersUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((updateCardFormField, inputPropertyToUpdate, inputIsUserEditedPropertyToUpdate, cardId, value, createAnalyticsEvent, analyticsSource, shouldUpdateUserEdited = true)=>{
    updateCardFormField(cardId, {
        [inputPropertyToUpdate]: value,
        [inputIsUserEditedPropertyToUpdate]: shouldUpdateUserEdited
    });
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'edited',
            actionSubject: inputPropertyToUpdate,
            source: analyticsSource
        }
    }).fire();
}, 400); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9383a3ed04c2259$var$RecommendedWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1p1dglyw _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $c9383a3ed04c2259$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
const $c9383a3ed04c2259$var$getFieldsToUpdateOnLinkSelect = async (selectedLink, fetchCoverImageUrl, cardImage, cardTitle, cardDescription, isTitleUserEdited, isDescriptionUserEdited, submitError)=>{
    let fieldsToUpdate = (0, $e51Sk.updateLinkAndConfluencePageId)(selectedLink.url, '', true);
    try {
        const client = new (0, $k00oi.default)();
        const queriedMetadata = await client.fetchData(selectedLink.url);
        const { name: name, image: image, summary: summary } = queriedMetadata?.data || {};
        const { objectId: objectId, resourceType: resourceType } = queriedMetadata?.meta || {};
        fieldsToUpdate = {
            ...fieldsToUpdate,
            ...(0, $e51Sk.updateLinkAndConfluencePageId)(selectedLink.url, objectId, true, resourceType)
        };
        if (!cardTitle || isTitleUserEdited === false) {
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).TITLE] = name;
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED] = false;
        }
        if (!cardDescription || isDescriptionUserEdited === false) {
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).DESCRIPTION] = summary;
            fieldsToUpdate[(0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = false;
        } // Updating imageSrc and imageAltText
        let newImageSrc = cardImage || '';
        const newImageAltText = '';
        const coverImage = await fetchCoverImageUrl(objectId, image);
        if (coverImage) {
            const isExternalSiteImage = $c9383a3ed04c2259$var$externalSiteMatcher.test(coverImage);
            if (!(0, $iqWjJ.isUnsplashImage)(coverImage) && !isExternalSiteImage) // For custom uploaded image save it in format `contentId/imageId`
            newImageSrc = `${objectId}/${coverImage}`;
            else newImageSrc = coverImage;
        }
        fieldsToUpdate = {
            ...fieldsToUpdate,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: newImageSrc,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: newImageAltText
        };
    } catch (error) {
        submitError?.(error);
    }
    return fieldsToUpdate;
};
const $c9383a3ed04c2259$export$cc05dad3d91e8c95 = ({ cardParameters: cardParameters, updateCardFormField: updateCardFormField, isDisabled: isDisabled, showDescription: showDescription, showLabel: showLabel, layout: layout, size: size })=>{
    const { cardId: cardId, link: link, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isTitleUserEdited: isTitleUserEdited, isDescriptionUserEdited: isDescriptionUserEdited, imageSrc: imageSrc, confluencePageId: confluencePageId, linkResourceType: linkResourceType } = cardParameters;
    const { cloudId: cloudId, submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const [titleValue, setTitleValue] = (0, $42omo.useState)(title);
    const [descriptionValue, setDescriptionValue] = (0, $42omo.useState)(description);
    const [labelValue, setLabelValue] = (0, $42omo.useState)(label);
    const [isLabelHiddenValue, setIsLabelHiddenValue] = (0, $42omo.useState)(isLabelHidden);
    const [labelColorValue, setLabelColorValue] = (0, $42omo.useState)(labelColor);
    const [isAILoading, setIsAILoading] = (0, $42omo.useState)();
    const [aiDescriptionContent, setAIDescriptionContent] = (0, $42omo.useState)();
    const [aiError, setAIError] = (0, $42omo.useState)();
    const [aiResponseState, setAIResponseState] = (0, $42omo.useState)();
    const linkId = `link-field-${cardId}`;
    const titleId = `title-field-${cardId}`;
    const descriptionId = `description-field-${cardId}`;
    const labelId = `label-field-${cardId}`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleDescriptionChange = (0, $42omo.useCallback)((value, aiValue)=>{
        setDescriptionValue(value);
        $c9383a3ed04c2259$var$debouncedParametersUpdate(updateCardFormField, (0, $4cOi8.ITEM_FIELDS).DESCRIPTION, (0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED, cardId, value, createAnalyticsEvent, (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE), !aiValue);
    }, [
        updateCardFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const handleTitleOnChange = (0, $42omo.useCallback)((event)=>{
        const { value: value } = event.currentTarget;
        setTitleValue(value.trimStart());
        $c9383a3ed04c2259$var$debouncedParametersUpdate(updateCardFormField, (0, $4cOi8.ITEM_FIELDS).TITLE, (0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED, cardId, value.trimStart(), createAnalyticsEvent, (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE));
    }, [
        updateCardFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const handleLabelChange = (0, $42omo.useCallback)((value)=>{
        setLabelValue(value);
        $c9383a3ed04c2259$var$debouncedParametersUpdate(updateCardFormField, (0, $4cOi8.ITEM_FIELDS).LABEL, true, cardId, value, createAnalyticsEvent, (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE));
    }, [
        updateCardFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const handleIsLabelHiddenChange = (0, $42omo.useCallback)((value)=>{
        setIsLabelHiddenValue(value);
        updateCardFormField(cardId, {
            [(0, $4cOi8.ITEM_FIELDS).IS_LABEL_HIDDEN]: value
        });
    }, [
        updateCardFormField,
        cardId
    ]);
    const handleLabelColorChange = (0, $42omo.useCallback)((value)=>{
        setLabelColorValue(value);
        updateCardFormField(cardId, {
            [(0, $4cOi8.ITEM_FIELDS).LABEL_COLOR]: value
        });
    }, [
        updateCardFormField,
        cardId
    ]);
    const fetchCoverImageUrl = (0, $d0hoS.useFetchCoverImage)((0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE));
    const handleSelectLink = (0, $42omo.useCallback)(async (selectedLink)=>{
        const fieldsToUpdate = await $c9383a3ed04c2259$var$getFieldsToUpdateOnLinkSelect(selectedLink, fetchCoverImageUrl, imageSrc, title, description, isTitleUserEdited || false, isDescriptionUserEdited || false, submitError);
        updateCardFormField(cardId, fieldsToUpdate);
    }, [
        cardId,
        imageSrc,
        title,
        description,
        isTitleUserEdited,
        isDescriptionUserEdited,
        fetchCoverImageUrl,
        updateCardFormField,
        submitError
    ]);
    const handleClearLink = (0, $42omo.useCallback)(()=>{
        const fieldsToClear = {
            ...(0, $e51Sk.updateLinkAndConfluencePageId)('', '')
        };
        if (isTitleUserEdited === false) {
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).TITLE] = '';
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED] = undefined;
        }
        if (isDescriptionUserEdited === false) {
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).DESCRIPTION] = '';
            fieldsToClear[(0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = undefined;
            setIsAILoading(undefined);
        }
        updateCardFormField(cardId, fieldsToClear);
    }, [
        updateCardFormField,
        cardId,
        isTitleUserEdited,
        isDescriptionUserEdited
    ]);
    (0, $42omo.useEffect)(()=>{
        // Sets title from prop
        setTitleValue(title); // If user triggers AI, set the the AI-generated content
        if (isAILoading && aiDescriptionContent && aiResponseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse) {
            updateCardFormField(cardId, {
                description: aiDescriptionContent,
                isDescriptionUserEdited: false
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'edited',
                    actionSubject: (0, $4cOi8.ITEM_FIELDS).DESCRIPTION,
                    source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        isAIGenerated: true
                    }
                }
            }).fire();
            setIsAILoading(false);
        }
        setDescriptionValue(description); // Sets AI response loading state to false if AI error
        if (aiError && (0, (/*@__PURE__*/$parcel$interopDefault($448e363c019d94a8$exports)))(isAILoading)) setIsAILoading(false);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        aiDescriptionContent,
        description,
        title,
        handleDescriptionChange,
        isAILoading,
        aiError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                htmlFor: linkId,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jCIc5.PanelSubheader), {
                    showUpdatedStyles: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $6f290cfa855699b1$export$defe85febe8b728c).linkFieldLabel
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8jjEv.LinkPicker), {
                cloudId: cloudId,
                link: link,
                id: linkId,
                title: title,
                handleSelectLink: handleSelectLink,
                handleClearLink: handleClearLink,
                isDisabled: isDisabled
            }),
            layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT && showLabel && size !== (0, $4cOi8.Height).SMALL && (0, $dh538.fg)('company_hub_cards_v2') && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $c9383a3ed04c2259$var$styles.fieldWrapperStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2b0b43c79c6ed957$export$239fbcd864262455), {
                    labelId: labelId,
                    labelValue: labelValue?.trimStart(),
                    handleLabelChange: handleLabelChange,
                    isLabelHiddenValue: isLabelHiddenValue,
                    handleIsLabelHiddenChange: handleIsLabelHiddenChange,
                    labelColorValue: labelColorValue,
                    handleLabelColorChange: handleLabelColorChange
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                xcss: $c9383a3ed04c2259$var$styles.fieldWrapperStyles,
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                        htmlFor: titleId,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $jCIc5.PanelSubheader), {
                            showUpdatedStyles: true,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $6f290cfa855699b1$export$defe85febe8b728c).titleFieldLabel
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)($c9383a3ed04c2259$var$RecommendedWrapper, {
                                    children: [
                                        ' ',
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $6f290cfa855699b1$export$defe85febe8b728c).recommendedFieldLabel
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                        id: titleId,
                        value: titleValue?.trimStart(),
                        onChange: handleTitleOnChange,
                        maxLength: 255,
                        isDisabled: isDisabled
                    })
                ]
            }),
            showDescription && /*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
                config: {
                    product: 'confluence',
                    subproduct: 'confluence',
                    aiFeatureName: 'companyHubCardsAIDescription',
                    proactiveGeneratedAI: 0,
                    userGeneratedAI: 1,
                    source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    isAIFeature: 1
                },
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    xcss: $c9383a3ed04c2259$var$styles.fieldWrapperStyles,
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                            htmlFor: descriptionId,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jCIc5.PanelSubheader), {
                                showUpdatedStyles: true,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $6f290cfa855699b1$export$defe85febe8b728c).descriptionFieldLabel
                                })
                            })
                        }),
                        confluencePageId && linkResourceType && /*#__PURE__*/ (0, $l998X.jsx)((0, $d78df4d96d7aa87e$export$4e2e1778ae07237), {
                            confluencePageId: confluencePageId,
                            linkResourceType: linkResourceType,
                            isAILoading: isAILoading,
                            setIsAILoading: setIsAILoading,
                            setAIError: setAIError,
                            setAIDescriptionContent: setAIDescriptionContent,
                            setAIResponseState: setAIResponseState,
                            analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
                        }),
                        isAILoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dOOm2.AIBorder), {
                            loading: true,
                            useModalStyles: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $c9383a3ed04c2259$var$styles.aiLoadingTextContainer,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $au4KV.AIStreamLoading), {
                                    padding: "space.250"
                                })
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                    id: descriptionId,
                                    rows: 3,
                                    value: descriptionValue?.trimStart(),
                                    onChange: (event)=>{
                                        setIsAILoading(undefined);
                                        handleDescriptionChange(event.currentTarget.value);
                                    },
                                    maxLength: 700,
                                    isDisabled: isDisabled,
                                    testId: "card-description-field"
                                }),
                                aiResponseState && (0, (/*@__PURE__*/$parcel$interopDefault($448e363c019d94a8$exports)))(isAILoading) && /*#__PURE__*/ (0, $l998X.jsx)((0, $36f4f0d8277b2fba$export$f1233e533b345659), {
                                    responseState: aiResponseState,
                                    error: aiError,
                                    analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};





const $6e090c38fd297175$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    backgroundColor: {
        id: "company-hub.cards-extension.card.background.color",
        defaultMessage: "Background color"
    },
    textColor: {
        id: "company-hub.cards-extension.card.text.color",
        defaultMessage: "Text color"
    },
    colorValidationSuccessMessage: {
        id: "company-hub.cards-extension.card.color-contrast.success",
        defaultMessage: "Your text and background colors work well for readability."
    },
    colorValidationFailMessage: {
        id: "company-hub.cards-extension.card.color-contrast.fail",
        defaultMessage: "Your text and background colors don\u2019t work well for readability."
    }
});


const $b02fd552a6765ca6$var$styles = {
    wrapper: "_1wpz1fhb _2lx21bp4 _19pku2gc _otyru2gc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    bgAndTextColorOptionsWrapper: "_19pkpxbi"
};
const $b02fd552a6765ca6$export$64ef9b8c11710c47 = ({ cardParameters: cardParameters, contentId: contentId, initialUnsplashResults: initialUnsplashResults, isDisabled: isDisabled, isNoImageAllowed: isNoImageAllowed, showDescription: showDescription, layout: layout, size: size, showSegmentation: showSegmentation, showBgAndTextColorOptions: showBgAndTextColorOptions, updateCardFormField: updateCardFormField, showMediaPicker: showMediaPicker, showLabel: showLabel })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cardId: cardId, imageSrc: imageSrc, imageAltText: imageAltText, confluencePageId: confluencePageId, audienceSegmentationGroupIds: audienceSegmentationGroupIds, backgroundColor: backgroundColor = (0, $e51Sk.cardNewParametersV4).backgroundColor, textColor: textColor = (0, $e51Sk.cardNewParametersV4).textColor } = cardParameters;
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, isCompanyHub: isCompanyHub, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker, branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const isReadableBackgroundColor = (color)=>(0, $fQWPs.isReadable)(color, textColor);
    const isReadableTextColor = (color)=>(0, $fQWPs.isReadable)(color, backgroundColor);
    const updateBackgroundColor = (bgColor)=>{
        updateCardFormField(cardId, {
            [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: bgColor
        });
    };
    const updateTextColor = (color)=>{
        updateCardFormField(cardId, {
            [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: color
        });
    };
    (0, $7Ux0V.useAutoTransitioningColors)(backgroundColor, isReadableTextColor, textColor, updateTextColor, branding?.defaultParameters);
    const handleOnGroupSelected = (selectedGroups)=>{
        updateCardFormField(cardId, {
            [(0, $4cOi8.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: selectedGroups
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $b02fd552a6765ca6$var$styles.wrapper,
        children: [
            showSegmentation && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                paddingBlock: "space.100",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $369b00ffe50c9c44$export$2261f4215d6c3d25), {
                    targetGroupsIds: audienceSegmentationGroupIds,
                    onGroupSelected: handleOnGroupSelected,
                    showUpdatedStyles: true,
                    source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c9383a3ed04c2259$export$cc05dad3d91e8c95), {
                cardParameters: cardParameters,
                updateCardFormField: updateCardFormField,
                isDisabled: isDisabled,
                showDescription: showDescription,
                showLabel: showLabel,
                layout: layout,
                size: size
            }),
            showMediaPicker ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7XNwX.ImageField), {
                shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
                analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                itemId: cardId,
                contentId: contentId,
                imageSrc: imageSrc,
                imageAltText: imageAltText,
                updateItemFormField: updateCardFormField
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $7lwhH.UnsplashSearchField), {
                itemId: cardId,
                idPrefix: "card",
                imageSrc: imageSrc,
                imageAltText: imageAltText,
                updateItemFormField: updateCardFormField,
                initialUnsplashResults: initialUnsplashResults,
                contentId: contentId,
                confluencePageId: confluencePageId,
                isNoImageAllowed: isNoImageAllowed,
                analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
            }),
            showBgAndTextColorOptions && /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.200",
                xcss: $b02fd552a6765ca6$var$styles.bgAndTextColorOptionsWrapper,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $6e090c38fd297175$export$defe85febe8b728c).backgroundColor
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                                builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                                isReadableColor: isReadableBackgroundColor,
                                onChange: updateBackgroundColor,
                                value: backgroundColor,
                                pickerTitle: (0, $6e090c38fd297175$export$defe85febe8b728c).backgroundColor,
                                validationSuccessMessage: formatMessage((0, $6e090c38fd297175$export$defe85febe8b728c).colorValidationSuccessMessage),
                                validationFailMessage: formatMessage((0, $6e090c38fd297175$export$defe85febe8b728c).colorValidationFailMessage),
                                showCustomPalette: isCompanyHub,
                                analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $6e090c38fd297175$export$defe85febe8b728c).textColor
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                                builtInColorMap: hideDefaultColorPalette ? emptyColorMap : textColorMap,
                                isReadableColor: isReadableTextColor,
                                onChange: updateTextColor,
                                value: textColor,
                                pickerTitle: (0, $6e090c38fd297175$export$defe85febe8b728c).textColor,
                                validationSuccessMessage: formatMessage((0, $6e090c38fd297175$export$defe85febe8b728c).colorValidationSuccessMessage),
                                validationFailMessage: formatMessage((0, $6e090c38fd297175$export$defe85febe8b728c).colorValidationFailMessage),
                                showCustomPalette: isCompanyHub,
                                analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                                showTextIcon: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $725e60c65b982e27$var$actionSubjectIdPostFix = 'Card';
const $725e60c65b982e27$export$b3865b40066cd705 = ({ ...cardsAreaContainerProps })=>{
    const { items: items, contentId: contentId, isNoImageAllowed: isNoImageAllowed, showBgAndTextColorOptions: showBgAndTextColorOptions, showDescription: showDescription, layout: layout, size: size, showMediaPicker: showMediaPicker, showSegmentation: showSegmentation, showLabel: showLabel, updateCardFormField: updateCardFormField } = cardsAreaContainerProps;
    const initialUnsplashResults = (0, $izxBd.useInitialUnsplashResults)(items);
    const renderCardContent = (cardParameters, isCardDisabled)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $b02fd552a6765ca6$export$64ef9b8c11710c47), {
            cardParameters: cardParameters,
            contentId: contentId,
            initialUnsplashResults: initialUnsplashResults,
            isDisabled: isCardDisabled,
            isNoImageAllowed: isNoImageAllowed,
            showBgAndTextColorOptions: showBgAndTextColorOptions,
            showDescription: showDescription,
            layout: layout,
            size: size,
            showMediaPicker: showMediaPicker,
            showSegmentation: showSegmentation,
            showLabel: showLabel,
            updateCardFormField: updateCardFormField
        });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2oKNO.ItemsListBuilder), {
        analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
        actionSubjectIdPostFix: $725e60c65b982e27$var$actionSubjectIdPostFix,
        renderItemContent: renderCardContent,
        ...cardsAreaContainerProps
    });
};




















var $8258c4c42c170e42$export$63d216eda7dcfec9 = /*#__PURE__*/ function(CONDITIONAL_FIELDS) {
    CONDITIONAL_FIELDS["IS_AVATAR_SHOWN"] = "isAvatarShown";
    CONDITIONAL_FIELDS["IS_PUBLISH_DATE_SHOWN"] = "isPublishDateShown";
    CONDITIONAL_FIELDS["IS_SOCIAL_STATS_SHOWN"] = "isSocialStatsShown";
    CONDITIONAL_FIELDS["IS_ICON_SHOWN"] = "isIconShown";
    CONDITIONAL_FIELDS["IS_LABEL_SHOWN"] = "isLabelShown";
    CONDITIONAL_FIELDS["IS_SEGMENTATION_SHOWN"] = "isSegmentationShown";
    CONDITIONAL_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    return CONDITIONAL_FIELDS;
}({});




var $k1IsV = parcelRequire("k1IsV");












var $bGmGb = parcelRequire("bGmGb");




const $5a92904f11c761fa$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    publishDateToggleLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label-v2",
        defaultMessage: "Last updated"
    },
    avatarToggleLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label-v2",
        defaultMessage: "Content owner"
    },
    labelToggleLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.label.label-v2",
        defaultMessage: "Label"
    },
    descriptionToggleLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.ai-description.label-v2",
        defaultMessage: "Description"
    },
    socialStatsToggleLabel: {
        id: "company-hub.cards-extension.card-config-panel.content-section.display-options.social-stats-toggle-label",
        defaultMessage: "Social stats"
    },
    iconToggleLabel: {
        id: "company-hub.cards-extension.card-config-panel.content-section.display-options.icon-toggle-label",
        defaultMessage: "Icon"
    }
});


const { IS_AVATAR_SHOWN: $8659c9c254ff6e3a$var$IS_AVATAR_SHOWN, IS_PUBLISH_DATE_SHOWN: $8659c9c254ff6e3a$var$IS_PUBLISH_DATE_SHOWN, IS_SOCIAL_STATS_SHOWN: $8659c9c254ff6e3a$var$IS_SOCIAL_STATS_SHOWN, IS_ICON_SHOWN: $8659c9c254ff6e3a$var$IS_ICON_SHOWN, IS_LABEL_SHOWN: $8659c9c254ff6e3a$var$IS_LABEL_SHOWN, IS_DESCRIPTION_SHOWN: $8659c9c254ff6e3a$var$IS_DESCRIPTION_SHOWN } = (0, $8258c4c42c170e42$export$63d216eda7dcfec9);
const $8659c9c254ff6e3a$export$46763ff84295d762 = ({ renderVariant: renderVariant, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isLabelShown: isLabelShown, isDescriptionShown: isDescriptionShown, layout: layout, size: size, updateMainFormField: updateMainFormField })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $fOKpq.useProductDependencies)();
    const handleAvatarToggleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            [$8659c9c254ff6e3a$var$IS_AVATAR_SHOWN]: !isAvatarShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'ownerToggle',
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isAvatarShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isAvatarShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handlePublishDateToggleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            [$8659c9c254ff6e3a$var$IS_PUBLISH_DATE_SHOWN]: !isPublishDateShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'lastUpdateToggle',
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isPublishDateShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isPublishDateShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handleSocialStatsToggleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            [$8659c9c254ff6e3a$var$IS_SOCIAL_STATS_SHOWN]: !isSocialStatsShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'socialStatsToggle',
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isSocialStatsShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isSocialStatsShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handleIconToggleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            [$8659c9c254ff6e3a$var$IS_ICON_SHOWN]: !isIconShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'iconToggle',
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isIconShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isIconShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handleLabelToggleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            [$8659c9c254ff6e3a$var$IS_LABEL_SHOWN]: !isLabelShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'labelToggle',
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isLabelShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isLabelShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handleDescriptionToggleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            [$8659c9c254ff6e3a$var$IS_DESCRIPTION_SHOWN]: !isDescriptionShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'descriptionToggle',
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isDescriptionShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isDescriptionShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $k1IsV.ToggleField), {
                label: formatMessage((0, $5a92904f11c761fa$export$defe85febe8b728c).avatarToggleLabel),
                isChecked: isAvatarShown,
                onChange: handleAvatarToggleChange
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $k1IsV.ToggleField), {
                label: formatMessage((0, $5a92904f11c761fa$export$defe85febe8b728c).publishDateToggleLabel),
                isChecked: isPublishDateShown,
                onChange: handlePublishDateToggleChange
            }),
            size !== (0, $4cOi8.Height).SMALL && (0, $dh538.fg)('company_hub_cards_visual_update') && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $k1IsV.ToggleField), {
                        label: formatMessage((0, $5a92904f11c761fa$export$defe85febe8b728c).socialStatsToggleLabel),
                        isChecked: isSocialStatsShown,
                        onChange: handleSocialStatsToggleChange
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $k1IsV.ToggleField), {
                        label: formatMessage((0, $5a92904f11c761fa$export$defe85febe8b728c).iconToggleLabel),
                        isChecked: isIconShown,
                        onChange: handleIconToggleChange
                    })
                ]
            }),
            layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT && renderVariant === (0, $4cOi8.RenderVariant).MANUAL && size !== (0, $4cOi8.Height).SMALL && (0, $dh538.fg)('company_hub_cards_v2') && /*#__PURE__*/ (0, $l998X.jsx)((0, $k1IsV.ToggleField), {
                label: formatMessage((0, $5a92904f11c761fa$export$defe85febe8b728c).labelToggleLabel),
                isChecked: isLabelShown,
                onChange: handleLabelToggleChange
            }),
            renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC && size !== (0, $4cOi8.Height).SMALL && (0, $dh538.fg)('company_hub_dynamic_cards_ai_descriptions') && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $k1IsV.ToggleField), {
                        label: formatMessage((0, $5a92904f11c761fa$export$defe85febe8b728c).descriptionToggleLabel),
                        isChecked: isDescriptionShown,
                        onChange: handleDescriptionToggleChange
                    }),
                    isAdminHubAIEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $bGmGb.CardsAIDisclaimer), {})
                ]
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $6xdDU = parcelRequire("6xdDU");







parcelRequire("42omo");








var $lW0cT = parcelRequire("lW0cT");





var $ahBBH = parcelRequire("ahBBH");







const $5566ed582ec5b621$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    cardCountLabel: {
        id: "company-hub.cards-extension.link-cards-content.card-components.card-count-label",
        defaultMessage: "Number of cards"
    },
    viewCurrentFilters: {
        id: "company-hub.cards-extension.link-cards-content.card-components.view-current-filters",
        defaultMessage: "View current filters"
    }
});


const $c9cdab23698c3ed2$export$b3a9c0e92d1dd6d5 = ({ viewFilters: viewFilters, extensionParameters: extensionParameters, extensionActions: extensionActions })=>{
    const { cardCount: cardCount } = extensionParameters;
    const { updateMainFormField: updateMainFormField } = extensionActions;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                shouldFitContainer: true,
                appearance: "primary",
                onClick: viewFilters,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    gap: "space.100",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))), {
                            label: ""
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $5566ed582ec5b621$export$defe85febe8b728c).viewCurrentFilters
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ahBBH.RangeField), {
                analyticSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                label: (0, $5566ed582ec5b621$export$defe85febe8b728c).cardCountLabel,
                maxValue: 20,
                minValue: 1,
                prefix: "card",
                updateRangeValue: (value)=>updateMainFormField({
                        cardCount: value
                    }),
                value: cardCount
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $hwDTW = parcelRequire("hwDTW");











var $1Whri = parcelRequire("1Whri");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");







var $4ERNs = parcelRequire("4ERNs");


var $4sOnC = parcelRequire("4sOnC");




const $2232cb2b9deb5e89$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    header: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header",
        defaultMessage: "Build dynamic cards"
    },
    headerSubtext: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header-subtext",
        defaultMessage: "Create a customized set of automatically populated cards that display the latest information. Use filters to select card content by label, space, owner, and more."
    },
    clearAllFiltersButton: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.clear-all-filters-button",
        defaultMessage: "Clear all filters"
    },
    cancelButton: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.cancel-button",
        defaultMessage: "Cancel"
    },
    confirmButton: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.confirm-button",
        defaultMessage: "Confirm"
    }
});












var $l3R5C = parcelRequire("l3R5C");






var $eqHN5 = parcelRequire("eqHN5");

const $a2fe61f868f043b5$export$a060942263c7e065 = ({ filters: filters, setFilters: setFilters })=>{
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $fOKpq.useProductDependencies)();
    const getSpaceIdsFromSpaceKeys = (0, $l3R5C.useGetSpaceIdsFromSpaceKeys)();
    const userDetails = (0, $42omo.useMemo)(()=>{
        return {
            id: userId ?? null,
            name: displayName ?? null
        };
    }, [
        userId,
        displayName
    ]);
    const mapUserIdToProfileUrl = (0, $42omo.useCallback)((userId)=>`/wiki/people/${userId}`, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "search-hub-container",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eqHN5.SearchPage), {
            shell: {
                cloudId: cloudId,
                orgId: orgId,
                user: userDetails,
                primaryProduct: (0, $4sOnC.ProductKeys).Confluence,
                queryParams: filters,
                isAdminHubAIEnabled: isAdminHubAIEnabled
            },
            callbacks: {
                updateQueryParameters: setFilters,
                getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
            },
            mapUserIdToProfileUrl: mapUserIdToProfileUrl
        })
    });
};


const $52b0f333f6bf1420$var$styles = {
    header: "_zulppxbi _2lx21bp4",
    footer: "_1bah1yb4 _1bsb1osq"
};
const $52b0f333f6bf1420$var$productFilter = {
    product: (0, $4sOnC.ProductKeys).Confluence
};
const $52b0f333f6bf1420$export$f05828d0709ad5e0 = (filters = {})=>{
    const { product: product, sortField: sortField, sortOrder: sortOrder, ...rest } = filters;
    return !(0, (/*@__PURE__*/$parcel$interopDefault($hwDTW)))(rest);
};
const $52b0f333f6bf1420$var$isSortDefault = ({ sortField: sortField, sortOrder: sortOrder })=>{
    const field = sortField || (0, $4ERNs.SORT_FIELD_KEY).LAST_MODIFIED_DATE;
    const order = sortOrder || (0, $4ERNs.SORT_ORDER).DESC;
    return field === (0, $4ERNs.SORT_FIELD_KEY).LAST_MODIFIED_DATE && order === (0, $4ERNs.SORT_ORDER).DESC;
};
const $52b0f333f6bf1420$export$d4af045235e509cb = ({ filters: filters, setFilters: setFilters, closeModal: closeModal })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [stagedFilters, setStagedFilters] = (0, $42omo.useState)({
        ...$52b0f333f6bf1420$var$productFilter,
        ...filters
    });
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'dynamicContentModalDialog'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const hasNoFilters = (0, $42omo.useMemo)(()=>{
        return !$52b0f333f6bf1420$export$f05828d0709ad5e0(stagedFilters) && $52b0f333f6bf1420$var$isSortDefault({
            sortField: stagedFilters.sortField,
            sortOrder: stagedFilters.sortOrder
        });
    }, [
        stagedFilters
    ]);
    const hasNoSearchFilters = (0, $42omo.useMemo)(()=>{
        return !$52b0f333f6bf1420$export$f05828d0709ad5e0(stagedFilters);
    }, [
        stagedFilters
    ]);
    const handleSetStagedFilters = (0, $42omo.useCallback)((newFilters)=>{
        setStagedFilters({
            ...newFilters
        });
    }, [
        setStagedFilters
    ]);
    const handleClearAllFilters = (0, $42omo.useCallback)(()=>{
        setStagedFilters({
            ...$52b0f333f6bf1420$var$productFilter
        });
    }, [
        setStagedFilters
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        closeModal();
    }, [
        closeModal
    ]);
    const handleConfirm = (0, $42omo.useCallback)(()=>{
        setFilters(stagedFilters);
        closeModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirmButton',
                source: 'dynamicContentModalDialog',
                attributes: {
                    filters: Object.keys(stagedFilters)
                }
            }
        }).fire();
    }, [
        stagedFilters,
        setFilters,
        closeModal,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
        onClose: closeModal,
        width: "x-large",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    xcss: (0, $1Whri.cx)($52b0f333f6bf1420$var$styles.header),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $2232cb2b9deb5e89$export$defe85febe8b728c).header
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $2232cb2b9deb5e89$export$defe85febe8b728c).headerSubtext
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a2fe61f868f043b5$export$a060942263c7e065), {
                    filters: stagedFilters,
                    setFilters: handleSetStagedFilters
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    xcss: (0, $1Whri.cx)($52b0f333f6bf1420$var$styles.footer),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            justifyContent: "start",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "subtle",
                                onClick: handleClearAllFilters,
                                isDisabled: hasNoFilters,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $2232cb2b9deb5e89$export$defe85febe8b728c).clearAllFiltersButton
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            justifyContent: "end",
                            gap: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    appearance: "subtle",
                                    onClick: handleCancel,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $2232cb2b9deb5e89$export$defe85febe8b728c).cancelButton
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    appearance: "primary",
                                    onClick: handleConfirm,
                                    isDisabled: hasNoSearchFilters,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $2232cb2b9deb5e89$export$defe85febe8b728c).confirmButton
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};





parcelRequire("42omo");








var $7hXDW = parcelRequire("7hXDW");





var $gj7hi = parcelRequire("gj7hi");





var $g50oa = parcelRequire("g50oa");




const $46bffb55f5ae4119$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noDynamicCards: {
        id: "company-hub.cards-extension.link-cards-content.card-components.error-states.no-dynamic-cards.header",
        defaultMessage: "No dynamic cards yet"
    },
    buildDynamicCards: {
        id: "company-hub.cards-extension.link-cards-content.card-components.build-dynamic-cards",
        defaultMessage: "Build dynamic cards"
    }
});


const $214b9247c9785b8a$export$2a511c47e1cb5779 = ({ startCreateFilters: startCreateFilters })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "space.200",
        testId: "empty-state-container",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($g50oa))),
                alt: "",
                testId: "no-dynamic-cards-image"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                size: "medium",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $46bffb55f5ae4119$export$defe85febe8b728c).noDynamicCards
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                shouldFitContainer: true,
                appearance: "primary",
                onClick: startCreateFilters,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    gap: "space.100",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lW0cT))), {
                            label: ""
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $46bffb55f5ae4119$export$defe85febe8b728c).buildDynamicCards
                        })
                    ]
                })
            })
        ]
    });
};


const $7f11cf0ca6136bea$var$styles = {
    disabledContentWrapper: "_80om13gf"
};
const $7f11cf0ca6136bea$export$1a61cdf7ea7768fd = ({ extensionParameters: extensionParameters, extensionActions: extensionActions, isDisabled: isDisabled })=>{
    const { filters: filters } = extensionParameters;
    const { updateMainFormField: updateMainFormField } = extensionActions;
    const hasFilters = !!filters;
    const [isDynamicContentModalOpen, setIsDynamicContentModalOpen] = (0, $42omo.useState)(false);
    const handleCloseModal = (0, $42omo.useCallback)(()=>setIsDynamicContentModalOpen(false), []);
    const handleOpenModal = (0, $42omo.useCallback)(()=>setIsDynamicContentModalOpen(true), []);
    const handleSetFilters = (newFilters)=>{
        updateMainFormField({
            filters: newFilters
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                direction: "column",
                gap: "space.300",
                xcss: isDisabled && $7f11cf0ca6136bea$var$styles.disabledContentWrapper,
                children: hasFilters ? /*#__PURE__*/ (0, $l998X.jsx)((0, $c9cdab23698c3ed2$export$b3a9c0e92d1dd6d5), {
                    viewFilters: handleOpenModal,
                    extensionParameters: extensionParameters,
                    extensionActions: extensionActions
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $214b9247c9785b8a$export$2a511c47e1cb5779), {
                    startCreateFilters: handleOpenModal
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: isDynamicContentModalOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $52b0f333f6bf1420$export$d4af045235e509cb), {
                    filters: filters,
                    closeModal: handleCloseModal,
                    setFilters: handleSetFilters
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $5nBzc = parcelRequire("5nBzc");









parcelRequire("42omo");





var $mXxnT = parcelRequire("mXxnT");




const $4e3a6e4dd583be33$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    manualRenderVariantDropdownOptionLabel: {
        id: "company-hub.company-hub-common.config-panel.render-variant.dropdown.option.label.manual",
        defaultMessage: "Manual"
    },
    dynamicRenderVariantDropdownOptionLabel: {
        id: "company-hub.company-hub-common.config-panel.render-variant.dropdown.option.label.dynamic",
        defaultMessage: "Dynamic"
    },
    dropdownLabel: {
        id: "company-hub.company-hub-common.config-panel.render-variant.dropdown.label",
        defaultMessage: "Card type"
    }
});


const $b2d59882694bee4e$var$manualOption = {
    label: (0, $4e3a6e4dd583be33$export$defe85febe8b728c).manualRenderVariantDropdownOptionLabel,
    value: (0, $4cOi8.RenderVariant).MANUAL
};
const $b2d59882694bee4e$var$dynamicOption = {
    label: (0, $4e3a6e4dd583be33$export$defe85febe8b728c).dynamicRenderVariantDropdownOptionLabel,
    value: (0, $4cOi8.RenderVariant).DYNAMIC
};
const $b2d59882694bee4e$var$renderVariantOptions = [
    $b2d59882694bee4e$var$manualOption,
    $b2d59882694bee4e$var$dynamicOption
];
const $b2d59882694bee4e$export$68edf4601962f4ab = ({ renderVariant: renderVariant, onUpdate: onUpdate, source: source })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $mXxnT.ConfigFieldDropdown), {
        fieldType: "render-variant",
        label: (0, $4e3a6e4dd583be33$export$defe85febe8b728c).dropdownLabel,
        onSelect: (selectedOption)=>onUpdate(selectedOption.value),
        options: $b2d59882694bee4e$var$renderVariantOptions,
        selectedOption: $b2d59882694bee4e$var$renderVariantOptions.find((option)=>option.value === renderVariant) || $b2d59882694bee4e$var$manualOption,
        renderVariant: renderVariant,
        source: source,
        showUpdatedStyles: true
    });



















const $d9c3f8e6252bf25b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    segmentationTargetLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-text.v2.label",
        defaultMessage: "Target audience"
    },
    segmentationNoneDropDownItemLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.v2.item.no-segmentation.label",
        defaultMessage: "None"
    },
    segmentationAllDropDownItemLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.all-cards.label",
        defaultMessage: "All cards"
    },
    segmentationEachDropDownItemLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.each-card.label",
        defaultMessage: "Each card"
    },
    infoIconLabelText: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.type-field.toggle.info-icon-label-v2",
        defaultMessage: "Choose which Confluence user groups will see your cards"
    }
});


const $73e5820bc532d33f$var$defaultOption = {
    label: (0, $d9c3f8e6252bf25b$export$defe85febe8b728c).segmentationNoneDropDownItemLabel,
    value: undefined
};
const $73e5820bc532d33f$var$manualSegmentationTargetOptions = [
    $73e5820bc532d33f$var$defaultOption,
    {
        label: (0, $d9c3f8e6252bf25b$export$defe85febe8b728c).segmentationAllDropDownItemLabel,
        value: (0, $4cOi8.SegmentationTargets).ALL
    },
    {
        label: (0, $d9c3f8e6252bf25b$export$defe85febe8b728c).segmentationEachDropDownItemLabel,
        value: (0, $4cOi8.SegmentationTargets).EACH
    }
];
const $73e5820bc532d33f$var$dynamicSegmentationTargetOptions = [
    $73e5820bc532d33f$var$defaultOption,
    {
        label: (0, $d9c3f8e6252bf25b$export$defe85febe8b728c).segmentationAllDropDownItemLabel,
        value: (0, $4cOi8.SegmentationTargets).ALL
    }
];
const $73e5820bc532d33f$export$83d97d5e49e73ce8 = ({ targetParameter: targetParameter, updateMainFormField: updateMainFormField, updateCardFormFieldForAllCards: updateCardFormFieldForAllCards, renderVariant: renderVariant, audienceSegmentationGroupIds: audienceSegmentationGroupIds, source: source })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const displayedSegmentationTargetOptions = renderVariant === (0, $4cOi8.RenderVariant).MANUAL ? $73e5820bc532d33f$var$manualSegmentationTargetOptions : $73e5820bc532d33f$var$dynamicSegmentationTargetOptions;
    const selectedOption = displayedSegmentationTargetOptions.find(({ value: value })=>value === targetParameter) || $73e5820bc532d33f$var$defaultOption;
    const handleSelect = (0, $42omo.useCallback)((selectedLabel)=>{
        const fieldsToUpdate = {
            segmentationTarget: selectedLabel.value,
            isSegmentationShown: selectedLabel.value !== undefined
        };
        if (selectedLabel.value === undefined) {
            //clear group preferences when set to none
            fieldsToUpdate.audienceSegmentationGroupIds = undefined;
            updateCardFormFieldForAllCards({
                [(0, $4cOi8.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: undefined
            });
        } else if (selectedLabel.value === (0, $4cOi8.SegmentationTargets).ALL && targetParameter === (0, $4cOi8.SegmentationTargets).EACH) //clear each group preferences when set to all from each
        updateCardFormFieldForAllCards({
            [(0, $4cOi8.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: undefined
        });
        else if (selectedLabel.value === (0, $4cOi8.SegmentationTargets).EACH && targetParameter === (0, $4cOi8.SegmentationTargets).ALL) {
            //transfer all group preferences to each when set to each from all
            fieldsToUpdate.audienceSegmentationGroupIds = undefined;
            updateCardFormFieldForAllCards({
                [(0, $4cOi8.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: audienceSegmentationGroupIds
            });
        }
        updateMainFormField(fieldsToUpdate);
    }, [
        updateMainFormField,
        updateCardFormFieldForAllCards,
        targetParameter,
        audienceSegmentationGroupIds
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $mXxnT.ConfigFieldDropdown), {
        fieldType: "segmentationTarget",
        label: (0, $d9c3f8e6252bf25b$export$defe85febe8b728c).segmentationTargetLabel,
        onSelect: handleSelect,
        options: displayedSegmentationTargetOptions,
        selectedOption: selectedOption,
        renderVariant: renderVariant,
        infoTooltip: formatMessage((0, $d9c3f8e6252bf25b$export$defe85febe8b728c).infoIconLabelText),
        showUpdatedStyles: true,
        source: source
    });
};









const $ccdf1e0f2502022b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    segmentationToggleLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label-v2",
        defaultMessage: "Target audience"
    },
    newLozengeLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label-v2",
        defaultMessage: "New"
    }
});


const $bc49242113d45efc$var$styles = {
    wrapper: "_1doce4h9 _1il9nqa1 _1o3i1l7x _n3tdpxbi",
    wrapperWithoutBorder: "_n3tdpxbi",
    marginBottom: "_otyr1b66"
};
const $bc49242113d45efc$export$fa828d8497c36e1b = ({ segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, renderVariant: renderVariant, extensionActions: extensionActions, updateRenderVariant: updateRenderVariant, cards: cards, source: source })=>{
    const { updateMainFormField: updateMainFormField, updateCardFormFieldForAllCards: updateCardFormFieldForAllCards } = extensionActions;
    const { enableTargeting: enableTargeting, enableUnifiedSearchFeatures: enableUnifiedSearchFeatures, enableSmartCardsFields: enableSmartCardsFields, isCompanyHub: isCompanyHub } = (0, $fOKpq.useProductDependencies)(); // isCompanyHub is false and enableTargeting is true for Non company hub such as confluence page
    const isTargetingEnabled = isCompanyHub && enableTargeting;
    const shouldShowSegmentationTargetGroupsField = segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL && isTargetingEnabled;
    const handleGroupSelection = (selectedGroups)=>{
        updateMainFormField({
            audienceSegmentationGroupIds: selectedGroups
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: enableSmartCardsFields ? $bc49242113d45efc$var$styles.wrapper : $bc49242113d45efc$var$styles.wrapperWithoutBorder,
        space: "space.200",
        testId: "cards-config-content-section-main",
        children: [
            enableUnifiedSearchFeatures && /*#__PURE__*/ (0, $l998X.jsx)((0, $b2d59882694bee4e$export$68edf4601962f4ab), {
                renderVariant: renderVariant,
                onUpdate: updateRenderVariant,
                source: source
            }),
            isTargetingEnabled && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $bc49242113d45efc$var$styles.marginBottom,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        appearance: "new",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $ccdf1e0f2502022b$export$defe85febe8b728c).newLozengeLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $73e5820bc532d33f$export$83d97d5e49e73ce8), {
                        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
                        updateMainFormField: updateMainFormField,
                        targetParameter: segmentationTarget,
                        updateCardFormFieldForAllCards: updateCardFormFieldForAllCards,
                        renderVariant: renderVariant,
                        source: source
                    })
                ]
            }),
            shouldShowSegmentationTargetGroupsField && /*#__PURE__*/ (0, $l998X.jsx)((0, $369b00ffe50c9c44$export$2261f4215d6c3d25), {
                targetGroupsIds: segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL ? audienceSegmentationGroupIds : cards[0]?.audienceSegmentationGroupIds,
                onGroupSelected: handleGroupSelection,
                showUpdatedStyles: true,
                source: source
            })
        ]
    });
};





const $332ff3f5b3359c67$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    listConfigContentTitleTextLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.title-text-label",
        defaultMessage: "Cards"
    },
    cardsInvalidMessage: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.error.invalid-list",
        defaultMessage: "Add cards"
    },
    preamble: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.text.description",
        defaultMessage: "Present links, images, and more. {link}"
    },
    preambleWithoutSupportLink: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.text.description-without-support-link",
        defaultMessage: "Present links, images, and more."
    },
    preambleSupportLinkLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.text.description.link",
        defaultMessage: "Learn more about cards."
    },
    stylesTabLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles-tab.label",
        defaultMessage: "Styles"
    },
    contentTabLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.content-tab.label",
        defaultMessage: "Content"
    },
    styleSectionGeneralTitle: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.style.general.title",
        defaultMessage: "General"
    },
    contentSectionDisplayOptionsTitle: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.content.display-options.title",
        defaultMessage: "Display options"
    },
    layoutsTitle: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.title",
        defaultMessage: "Layouts"
    },
    layoutsCardsFixedImageHeightLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.label",
        defaultMessage: "Fixed image height"
    },
    layoutsCardsFixedImageHeightDescription: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.description",
        defaultMessage: "Image size is the same on all cards"
    },
    layoutsCardsFlexibleImageHeightLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.label",
        defaultMessage: "Flexible image height"
    },
    layoutsCardsFlexibleImageHeightDescription: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.description",
        defaultMessage: "Image size responds to the amount of text"
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











var $cL1OY = parcelRequire("cL1OY");

var $aPCur = parcelRequire("aPCur");




























var $3gadb = parcelRequire("3gadb");










const $8fff7a9c71e5db8b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    autoscrollLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-label",
        defaultMessage: "Autoscroll"
    },
    autoscrollTooltipContent: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-tooltip-content",
        defaultMessage: "Cards that don\u2019t fit on the screen will start scrolling when you exit edit mode"
    }
});


const $1315b2bd967be608$export$600864a4e47981ae = ({ isAutoscrollEnabled: isAutoscrollEnabled, renderVariant: renderVariant, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            isAutoscrollEnabled: !isAutoscrollEnabled
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'toggle',
                actionSubjectId: 'autoscrollToggle',
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAutoscrollEnabled,
        renderVariant,
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $k1IsV.ToggleField), {
        label: formatMessage((0, $8fff7a9c71e5db8b$export$defe85febe8b728c).autoscrollLabel),
        Icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: formatMessage((0, $8fff7a9c71e5db8b$export$defe85febe8b728c).autoscrollTooltipContent),
            position: "bottom",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                testId: "autoscroll-information-icon",
                label: "autoscroll-information",
                color: "var(--ds-icon-discovery, #AF59E1)"
            })
        }),
        isChecked: isAutoscrollEnabled,
        onChange: handleChange
    });
};
































const $767b3e2fba3c28c2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    backgroundColorLabel: {
        id: "company-hub.card-extensions.card-config.background-color-field.title",
        defaultMessage: "Background color"
    }
});


const $9cc2ec7819350a74$export$f741b39ac4e5761a = ({ backgroundColor: backgroundColor, textColor: textColor, isCompanyHub: isCompanyHub, updateMainFormField: updateMainFormField })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const { branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const isReadableBackgroundColor = (color)=>(0, $fQWPs.isReadable)(color, textColor);
    const handleChange = (0, $42omo.useCallback)((color)=>{
        updateMainFormField({
            backgroundColor: color
        });
    }, [
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $767b3e2fba3c28c2$export$defe85febe8b728c).backgroundColorLabel
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE),
                builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                isReadableColor: isReadableBackgroundColor,
                onChange: handleChange,
                value: backgroundColor,
                pickerTitle: (0, $767b3e2fba3c28c2$export$defe85febe8b728c).backgroundColorLabel,
                showCustomPalette: !!isCompanyHub
            })
        ]
    });
};
































const $cfc8bf589e42b934$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    borderColor: {
        id: "company-hub.cards-extension.cards.config-panel.border.color",
        defaultMessage: "Border color"
    }
});


const $bc316cd1eeeb565b$export$92aacb76e2eb3993 = ({ borderColor: borderColor, isCompanyHub: isCompanyHub, updateMainFormField: updateMainFormField })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const { branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const defaultBorderColor = (0, $lhvsH.DEFAULT_GRAY_COLOR);
    const handleChange = (0, $42omo.useCallback)((color)=>{
        updateMainFormField({
            borderColor: color
        });
    }, [
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        spread: "space-between",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $cfc8bf589e42b934$export$defe85febe8b728c).borderColor
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                onChange: handleChange,
                value: borderColor || defaultBorderColor,
                pickerTitle: (0, $cfc8bf589e42b934$export$defe85febe8b728c).borderColor,
                showCustomPalette: isCompanyHub,
                analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE)
            })
        ]
    });
};









var $5tOl1 = parcelRequire("5tOl1");


var $aK2ZC = parcelRequire("aK2ZC");













const $6dff5c2e70306274$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    displayAsLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.display-as-label",
        defaultMessage: "Display as"
    },
    rowItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.row-label",
        defaultMessage: "Row"
    },
    rowItemDescription: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.row-description",
        defaultMessage: "Cards scroll in one row"
    },
    stackedItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.stacked-label",
        defaultMessage: "Stacked"
    },
    stackedItemDescription: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.stacked-description",
        defaultMessage: "Cards wrap to new lines"
    }
});


const $2660c37115f12894$var$orientationOptions = [
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
        label: (0, $6dff5c2e70306274$export$defe85febe8b728c).rowItemLabel,
        description: (0, $6dff5c2e70306274$export$defe85febe8b728c).rowItemDescription,
        value: (0, $5un3P.Orientation).ROW
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aK2ZC))),
        label: (0, $6dff5c2e70306274$export$defe85febe8b728c).stackedItemLabel,
        description: (0, $6dff5c2e70306274$export$defe85febe8b728c).stackedItemDescription,
        value: (0, $5un3P.Orientation).STACKED
    }
];
const $2660c37115f12894$var$defaultOption = $2660c37115f12894$var$orientationOptions[0];
const $2660c37115f12894$export$9866cfa35e402e69 = ({ orientation: orientation, renderVariant: renderVariant, updateMainFormField: updateMainFormField, showUpdatedStyles: showUpdatedStyles })=>{
    const selectedOption = $2660c37115f12894$var$orientationOptions.find(({ value: value })=>value === orientation) || $2660c37115f12894$var$defaultOption;
    const handleSelect = (0, $42omo.useCallback)((selectedLabel)=>{
        updateMainFormField({
            orientation: selectedLabel.value
        });
    }, [
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $mXxnT.ConfigFieldDropdown), {
        fieldType: "orientation",
        label: (0, $6dff5c2e70306274$export$defe85febe8b728c).displayAsLabel,
        onSelect: handleSelect,
        options: $2660c37115f12894$var$orientationOptions,
        renderVariant: renderVariant,
        selectedOption: selectedOption,
        showUpdatedStyles: showUpdatedStyles,
        source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    });
};























const $a968db887198d23c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    paddingLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.padding-label",
        defaultMessage: "Padding"
    }
});


const $c4b4c7674652ac02$export$915c99e84f1c148d = ({ isPaddingEnabled: isPaddingEnabled, renderVariant: renderVariant, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleChange = (0, $42omo.useCallback)(()=>{
        updateMainFormField({
            isPaddingEnabled: !isPaddingEnabled
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'toggle',
                actionSubjectId: 'paddingToggle',
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isPaddingEnabled,
        renderVariant,
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $k1IsV.ToggleField), {
        label: formatMessage((0, $a968db887198d23c$export$defe85febe8b728c).paddingLabel),
        isChecked: isPaddingEnabled,
        onChange: handleChange
    });
};




















const $2a72dddf5dfe1c38$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    sizeTextLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.size-text-label",
        defaultMessage: "Size"
    },
    sizeSmallDropDownItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.small.label",
        defaultMessage: "Small"
    },
    sizeMediumDropDownItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.medium.label",
        defaultMessage: "Medium"
    },
    sizeLargeDropDownItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.large.label",
        defaultMessage: "Large"
    }
});


const $45768bc82e75ccf2$export$7c15ddf1d318efda = [
    {
        label: (0, $2a72dddf5dfe1c38$export$defe85febe8b728c).sizeSmallDropDownItemLabel,
        value: (0, $4cOi8.Height).SMALL
    },
    {
        label: (0, $2a72dddf5dfe1c38$export$defe85febe8b728c).sizeMediumDropDownItemLabel,
        value: (0, $4cOi8.Height).MEDIUM
    },
    {
        label: (0, $2a72dddf5dfe1c38$export$defe85febe8b728c).sizeLargeDropDownItemLabel,
        value: (0, $4cOi8.Height).LARGE
    }
];



const $e1bde8a3c1d24a8f$export$2c78cba0f7eb6af1 = ({ sizeParameter: sizeParameter, renderVariant: renderVariant, updateMainFormField: updateMainFormField, showUpdatedStyles: showUpdatedStyles })=>{
    const { sizeOptions: sizeOptions, selectedOption: selectedOption } = {
        sizeOptions: (0, $45768bc82e75ccf2$export$7c15ddf1d318efda),
        selectedOption: (0, $45768bc82e75ccf2$export$7c15ddf1d318efda).find(({ value: value })=>value === sizeParameter) || (0, $45768bc82e75ccf2$export$7c15ddf1d318efda)[0]
    };
    const handleSelect = (0, $42omo.useCallback)((selectedLabel)=>{
        updateMainFormField({
            size: selectedLabel.value
        });
    }, [
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $mXxnT.ConfigFieldDropdown), {
        fieldType: "size",
        label: (0, $2a72dddf5dfe1c38$export$defe85febe8b728c).sizeTextLabel,
        onSelect: handleSelect,
        options: sizeOptions,
        selectedOption: selectedOption,
        renderVariant: renderVariant,
        showUpdatedStyles: showUpdatedStyles,
        source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    });
};
































const $41f41311bd35ae59$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    textColorLabel: {
        id: "company-hub.card-extensions.card-config.text-color-field.title",
        defaultMessage: "Text color"
    }
});


const $5a471777ee53bdff$export$f936dd91781178aa = ({ textColor: textColor, backgroundColor: backgroundColor, isCompanyHub: isCompanyHub, updateMainFormField: updateMainFormField })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette } = branding ?? {};
    const { textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const isReadableTextColor = (color)=>(0, $fQWPs.isReadable)(color, backgroundColor);
    const handleChange = (0, $42omo.useCallback)((color)=>{
        updateMainFormField({
            textColor: color
        });
    }, [
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $41f41311bd35ae59$export$defe85febe8b728c).textColorLabel
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE),
                builtInColorMap: hideDefaultColorPalette ? emptyColorMap : textColorMap,
                isReadableColor: isReadableTextColor,
                onChange: handleChange,
                value: textColor,
                pickerTitle: (0, $41f41311bd35ae59$export$defe85febe8b728c).textColorLabel,
                showCustomPalette: !!isCompanyHub
            })
        ]
    });
};


const $7816eca9d12f9e42$var$styles = {
    disabledContentWrapperStyles: "_80om13gf"
};
const $7816eca9d12f9e42$export$340caeb53b469bd1 = ({ extensionParameters: extensionParameters, extensionActions: extensionActions, isCompanyHub: isCompanyHub, isDisabled: isDisabled })=>{
    const { size: size, orientation: orientation, alignment: alignment, renderVariant: renderVariant, isAutoscrollEnabled: isAutoscrollEnabled, borderColor: borderColor, isPaddingEnabled: isPaddingEnabled, cornerStyle: cornerStyle, layout: layout, filters: filters, backgroundColor: // to account for when backgroundColor is undefined for cards created before visual updates
    backgroundColor = (0, $e51Sk.cardNewParametersV4).backgroundColor, textColor: // to account for when textColor is undefined for cards created before visual updates
    textColor = (0, $e51Sk.cardNewParametersV4).textColor } = extensionParameters;
    const { updateMainFormField: updateMainFormField, updateCornerStyle: updateCornerStyle } = extensionActions;
    const isUnpopulatedDynamicCards = renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC && !filters;
    const shouldShowAutoscrollToggle = isCompanyHub && orientation === (0, $5un3P.Orientation).ROW && !isUnpopulatedDynamicCards;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        testId: "styles-general-section",
        direction: "column",
        gap: "space.200",
        xcss: isDisabled && $7816eca9d12f9e42$var$styles.disabledContentWrapperStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $e1bde8a3c1d24a8f$export$2c78cba0f7eb6af1), {
                sizeParameter: size,
                renderVariant: renderVariant,
                updateMainFormField: updateMainFormField,
                showUpdatedStyles: true
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2660c37115f12894$export$9866cfa35e402e69), {
                orientation: orientation,
                renderVariant: renderVariant,
                updateMainFormField: updateMainFormField,
                showUpdatedStyles: true
            }),
            shouldShowAutoscrollToggle && /*#__PURE__*/ (0, $l998X.jsx)((0, $1315b2bd967be608$export$600864a4e47981ae), {
                isAutoscrollEnabled: isAutoscrollEnabled,
                renderVariant: renderVariant,
                updateMainFormField: updateMainFormField
            }),
            (0, $dh538.fg)('company_hub_cards_visual_update') && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9cc2ec7819350a74$export$f741b39ac4e5761a), {
                        textColor: textColor,
                        backgroundColor: backgroundColor,
                        isCompanyHub: isCompanyHub,
                        updateMainFormField: updateMainFormField
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5a471777ee53bdff$export$f936dd91781178aa), {
                        textColor: textColor,
                        backgroundColor: backgroundColor,
                        isCompanyHub: isCompanyHub,
                        updateMainFormField: updateMainFormField
                    })
                ]
            }),
            layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT && size !== (0, $4cOi8.Height).SMALL && (0, $dh538.fg)('company_hub_cards_v2') && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bc316cd1eeeb565b$export$92aacb76e2eb3993), {
                        borderColor: borderColor,
                        isCompanyHub: isCompanyHub,
                        updateMainFormField: updateMainFormField
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $c4b4c7674652ac02$export$915c99e84f1c148d), {
                        isPaddingEnabled: isPaddingEnabled,
                        renderVariant: renderVariant,
                        updateMainFormField: updateMainFormField
                    })
                ]
            }),
            isCompanyHub && (0, $dh538.fg)('company_hub_cards_visual_update') && /*#__PURE__*/ (0, $l998X.jsx)((0, $aPCur.CornerStyleConfig), {
                cornerStyleValue: cornerStyle ?? (0, $4cOi8.CornerStyle).ROUNDED,
                updateCornerStyle: updateCornerStyle,
                roundCornerValue: (0, $4cOi8.CornerStyle).ROUNDED,
                squareCornerValue: (0, $4cOi8.CornerStyle).SQUARED
            }),
            orientation === (0, $5un3P.Orientation).STACKED && /*#__PURE__*/ (0, $l998X.jsx)((0, $cL1OY.AlignmentField), {
                selectedAlignment: alignment,
                renderVariant: renderVariant,
                updateMainFormField: updateMainFormField,
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
            })
        ]
    });
};


const $e9c807d51145b0bc$export$af1b061943ec63f0 = [
    {
        label: (0, $332ff3f5b3359c67$export$defe85febe8b728c).layoutsCardsFixedImageHeightLabel,
        description: (0, $332ff3f5b3359c67$export$defe85febe8b728c).layoutsCardsFixedImageHeightDescription,
        value: (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT
    },
    {
        label: (0, $332ff3f5b3359c67$export$defe85febe8b728c).layoutsCardsFlexibleImageHeightLabel,
        description: (0, $332ff3f5b3359c67$export$defe85febe8b728c).layoutsCardsFlexibleImageHeightDescription,
        value: (0, $5un3P.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    }
];
var $e9c807d51145b0bc$var$TabSections = /*#__PURE__*/ function(TabSections) {
    TabSections["GENERAL"] = "general";
    TabSections["MAIN"] = "main";
    TabSections["DISPLAY_OPTIONS"] = "displayOptions";
    TabSections["CARDS"] = "cards";
    TabSections["LAYOUTS"] = "layouts";
    return TabSections;
}($e9c807d51145b0bc$var$TabSections || {});
var $e9c807d51145b0bc$var$TabValues = /*#__PURE__*/ function(TabValues) {
    TabValues["STYLES"] = "styles";
    TabValues["CONTENT"] = "content";
    return TabValues;
}($e9c807d51145b0bc$var$TabValues || {})// button keyboard accessibility spec: https://www.w3.org/WAI/ARIA/apg/patterns/button/examples/button/
;
const $e9c807d51145b0bc$var$TRIGGER_BUTTON_KEYS = [
    'Enter',
    'Spacebar',
    ' '
];
const $e9c807d51145b0bc$export$390155f95955bd70 = 20;
const $e9c807d51145b0bc$var$styles = {
    linkCardsListBuilderFooterWrapper: "_zulpu2gc _1rjc1ejb _1e0c1txw _2lx21bp4",
    stickyFooter: "_18zr1b66 _195gr5cr _kqsw1if8 _94n5ze3t _bfhkvuon"
};
const $e9c807d51145b0bc$var$CardsConfigPanelFeedbackCollector = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6r7Ix.ConfigPanelFeedbackCollector), {
        source: (0, $kcoxM.CARDS_EXTENSION_ANALYTIC_SOURCE),
        type: (0, $4cOi8.FeedbackType).CARDS
    });
};
const $e9c807d51145b0bc$export$388775c8ad90f12b = ({ contentId: contentId, closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions, extensionKey: extensionKey })=>{
    const { cardsActions: cardsActions, cardsParameters: cardsParameters } = (0, $e51Sk.useCardsExtensionParametersAndActions)({
        localId: localId,
        editorActions: editorActions
    });
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cards: cards, renderVariant: renderVariant, cardCount: cardCount, filters: filters, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isLabelShown: isLabelShown, segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, layout: layout, size: size, isDescriptionShown: isDescriptionShown } = cardsParameters || {};
    const { addCard: addCard, updateMainFormField: updateMainFormField, updateCardFormFieldForAllCards: updateCardFormFieldForAllCards } = cardsActions;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setIsInViewMode: setIsInViewMode } = (0, $g3LxX.useExtensionsActions)();
    const [tabSelected, setTabSelected] = (0, $42omo.useState)("styles");
    const cardsListRef = (0, $42omo.useRef)(null);
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    const { isCompanyHub: isCompanyHub, enableSmartCardsFields: enableSmartCardsFields, showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $fOKpq.useProductDependencies)();
    (0, $42omo.useEffect)(()=>{
        setIsInViewMode(false);
    }, [
        setIsInViewMode
    ]);
    const handleAddCardKeyPress = (event)=>{
        if ($e9c807d51145b0bc$var$TRIGGER_BUTTON_KEYS.includes(event.key)) setTimeout(()=>{
            cardsListRef?.current?.lastChild?.focus();
        }, 100);
    };
    const updateRenderVariant = (0, $42omo.useCallback)((value)=>{
        setIsInAutoFocusMode(false);
        const fieldsToUpdate = {
            renderVariant: value
        };
        if (value === (0, $4cOi8.RenderVariant).MANUAL) {
            if (cards.length === 0) fieldsToUpdate.cards = (0, $cKAxI.getDefaultCards)();
        }
        if (value === (0, $4cOi8.RenderVariant).DYNAMIC) {
            fieldsToUpdate.cardCount = cardCount || (0, $5un3P.DEFAULT_DYNAMIC_CARDS_COUNT);
            fieldsToUpdate.filters = filters || undefined;
        } // Clear segmentation target if it's set to EACH and switching variant
        if (segmentationTarget === (0, $4cOi8.SegmentationTargets).EACH) {
            fieldsToUpdate.segmentationTarget = undefined;
            fieldsToUpdate.isSegmentationShown = false;
            updateCardFormFieldForAllCards({
                [(0, $4cOi8.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: undefined
            });
        }
        updateMainFormField(fieldsToUpdate);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'renderVariantSwitcher',
                source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    renderVariant: value
                }
            }
        }).fire();
    }, [
        cards,
        setIsInAutoFocusMode,
        updateMainFormField,
        updateCardFormFieldForAllCards,
        cardCount,
        filters,
        createAnalyticsEvent,
        segmentationTarget
    ]);
    const handleTabClick = (0, $42omo.useCallback)((tab)=>{
        setTabSelected(tab.value);
    }, []);
    const renderConfigPanelFooter = (0, $42omo.useCallback)(()=>{
        const hasReachedCardLimit = cards?.length >= $e9c807d51145b0bc$export$390155f95955bd70;
        const isManualCard = renderVariant === (0, $4cOi8.RenderVariant).MANUAL;
        const isContentTabSelected = tabSelected === "content";
        const canShowCardsMessages = isManualCard && isContentTabSelected;
        const showAddCardsButton = !hasReachedCardLimit && canShowCardsMessages;
        const showCardsErrorMessage = !(0, $1VNax.checkItems)(cards) && canShowCardsMessages; // when Cards is disabled (ie. premium gated), don't show the footer
        if (isDisabled) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $e9c807d51145b0bc$var$styles.stickyFooter,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $e9c807d51145b0bc$var$styles.linkCardsListBuilderFooterWrapper,
                children: [
                    showAddCardsButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $dAbO5.AddItemButton), {
                        addItem: addCard,
                        onAddItemKeyPress: handleAddCardKeyPress,
                        analyticsSource: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                        actionSubjectIdSuffix: "Card"
                    }),
                    showCardsErrorMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $jD7cj.FormFieldErrorMessage), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $332ff3f5b3359c67$export$defe85febe8b728c).cardsInvalidMessage
                        })
                    }),
                    isContentTabSelected ? undefined : /*#__PURE__*/ (0, $l998X.jsx)($e9c807d51145b0bc$var$CardsConfigPanelFeedbackCollector, {})
                ]
            })
        });
    }, [
        cards,
        addCard,
        isDisabled,
        renderVariant,
        tabSelected
    ]);
    const previewImage = (0, $42omo.useCallback)((layout)=>{
        if (layout === (0, $5un3P.CardsLayout).FIXED_IMAGE_HEIGHT) return {
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($91cbe0ea0a5fc348$exports))),
            imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($2b814e09ffd55c03$exports)))
        };
        else return {
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($e602f7fca58afed2$exports))),
            imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($69017605bdf01986$exports)))
        };
    }, []);
    if (!cardsParameters) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1m9A2.NoExtensionData), {
        source: extensionKey,
        isConfigPanel: true
    });
    const updateCards = (cards)=>updateMainFormField({
            cards: cards
        });
    const tabSections = [
        {
            label: formatMessage((0, $332ff3f5b3359c67$export$defe85febe8b728c).stylesTabLabel),
            value: "styles",
            tabContent: [
                {
                    sectionId: "general",
                    title: formatMessage((0, $332ff3f5b3359c67$export$defe85febe8b728c).styleSectionGeneralTitle),
                    defaultIsExpanded: true,
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $7816eca9d12f9e42$export$340caeb53b469bd1), {
                        extensionParameters: cardsParameters,
                        extensionActions: cardsActions,
                        isCompanyHub: isCompanyHub,
                        isDisabled: isDisabled
                    })
                },
                ...size !== (0, $4cOi8.Height).SMALL && (0, $dh538.fg)('company_hub_cards_v2') ? [
                    {
                        sectionId: "layouts",
                        title: formatMessage((0, $332ff3f5b3359c67$export$defe85febe8b728c).layoutsTitle),
                        defaultIsExpanded: false,
                        component: /*#__PURE__*/ (0, $l998X.jsx)((0, $hECbK.LayoutOptions), {
                            updateLayout: cardsActions.updateLayout,
                            source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                            layoutOptions: $e9c807d51145b0bc$export$af1b061943ec63f0,
                            previewImage: previewImage,
                            currentLayoutSelection: layout
                        })
                    }
                ] : []
            ]
        },
        {
            label: formatMessage((0, $332ff3f5b3359c67$export$defe85febe8b728c).contentTabLabel),
            value: "content",
            tabContent: [
                {
                    sectionId: "main",
                    component: /*#__PURE__*/ (0, $l998X.jsx)((0, $bc49242113d45efc$export$fa828d8497c36e1b), {
                        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
                        renderVariant: renderVariant,
                        segmentationTarget: segmentationTarget,
                        cards: cards,
                        extensionActions: cardsActions,
                        updateRenderVariant: updateRenderVariant,
                        source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
                    })
                },
                ...enableSmartCardsFields && (renderVariant === (0, $4cOi8.RenderVariant).MANUAL || renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC && filters) ? [
                    {
                        title: formatMessage((0, $332ff3f5b3359c67$export$defe85febe8b728c).contentSectionDisplayOptionsTitle),
                        sectionId: "displayOptions",
                        defaultIsExpanded: false,
                        component: /*#__PURE__*/ (0, $l998X.jsx)((0, $8659c9c254ff6e3a$export$46763ff84295d762), {
                            isAvatarShown: isAvatarShown,
                            isPublishDateShown: isPublishDateShown,
                            isSocialStatsShown: isSocialStatsShown,
                            isIconShown: isIconShown,
                            isLabelShown: isLabelShown,
                            layout: layout,
                            size: size,
                            renderVariant: renderVariant,
                            updateMainFormField: updateMainFormField,
                            // and we want to enable the toggle by default
                            isDescriptionShown: isDescriptionShown !== false
                        })
                    }
                ] : [],
                {
                    sectionId: "cards",
                    defaultIsExpanded: false,
                    component: renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        paddingBlockStart: "space.400",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7f11cf0ca6136bea$export$1a61cdf7ea7768fd), {
                            extensionParameters: cardsParameters,
                            extensionActions: cardsActions,
                            isDisabled: isDisabled
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $725e60c65b982e27$export$b3865b40066cd705), {
                        items: cardsParameters.cards,
                        removeItem: cardsActions.removeCard,
                        updateCardFormField: cardsActions.updateCardFormField,
                        updateItems: updateCards,
                        contentId: contentId,
                        showDescription: cardsParameters.size !== (0, $4cOi8.Height).SMALL,
                        layout: cardsParameters.layout,
                        size: size,
                        showSegmentation: Boolean(cardsParameters.isSegmentationShown && cardsParameters.segmentationTarget === (0, $4cOi8.SegmentationTargets).EACH),
                        itemsListRef: cardsListRef,
                        isNoImageAllowed: true,
                        shouldUseCardV2UI: true,
                        showMediaPicker: true,
                        showLabel: isLabelShown
                    })
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6UUyu.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $332ff3f5b3359c67$export$defe85febe8b728c).listConfigContentTitleTextLabel
        }),
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $4LKV2.CardsExtensionIcon), {}),
        footerComponent: renderConfigPanelFooter,
        closeConfigPanel: closeConfigPanel,
        shouldUseCardV2Styles: true,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...showConfigPreambleSupportLink ? (0, $332ff3f5b3359c67$export$defe85febe8b728c).preamble : (0, $332ff3f5b3359c67$export$defe85febe8b728c).preambleWithoutSupportLink,
                    values: {
                        link: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            href: "https://support.atlassian.com/confluence-cloud/docs/display-beautiful-dynamic-content-on-your-page-with-cards/",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $332ff3f5b3359c67$export$defe85febe8b728c).preambleSupportLinkLabel
                            })
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3VS69.PremiumGateForExtensionConfigPanel), {
                feature: "premiumCardsConfig",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hjUk0.ConfigPanelGrouping), {
                    source: (0, $kcoxM.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    tabSections: tabSections,
                    onTabClick: handleTabClick
                })
            })
        ]
    });
};
module.exports["CardsConfigPanelContent"] = $e9c807d51145b0bc$export$388775c8ad90f12b;

});

parcelRegister("ahBBH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $c4sKh = parcelRequire("c4sKh");


var $gdv5Z = parcelRequire("gdv5Z");


var $epp7s = parcelRequire("epp7s");


var $fOKpq = parcelRequire("fOKpq");

const $041e11f907714e25$var$styles = {
    badgeContainer: "_19pkxmi2 _1bsb1ris",
    labelWrapper: "_ca0qutpp",
    wrapper: "_1e0c1txw _2lx2vrvc _1bah1yb4"
};
const $041e11f907714e25$export$b322c47b2525bd34 = ({ analyticSource: analyticSource, label: label, maxValue: maxValue, minValue: minValue, prefix: prefix, step: step = 1, unit: unit, updateRangeValue: updateRangeValue, value: value })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const handleRangeUpdate = (0, $42omo.useCallback)((newValue)=>{
        updateRangeValue(newValue);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'range',
                actionSubjectId: `${prefix}NumberRange`,
                source: analyticSource,
                attributes: {
                    value: newValue
                }
            }
        }).fire();
    }, [
        analyticSource,
        createAnalyticsEvent,
        prefix,
        updateRangeValue
    ]);
    if (typeof value !== 'number') {
        const error = new Error(`${prefix} range value should be a number but got: ${typeof value}`);
        submitError?.(error);
        return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "config-panel-range-field",
        xcss: $041e11f907714e25$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $041e11f907714e25$var$styles.labelWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)("label", {
                    htmlFor: "range-input",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...label
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $epp7s.default), {
                        id: "range-input",
                        onChange: handleRangeUpdate,
                        testId: "config-panel-range-field-range-input",
                        value: value,
                        step: step,
                        min: minValue,
                        max: maxValue
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $041e11f907714e25$var$styles.badgeContainer,
                        style: {
                            paddingLeft: `${Math.min(100 * Math.max(value - 1, 0) / maxValue, 90)}%`
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
                            children: value + (unit ? unit : '')
                        })
                    })
                ]
            })
        ]
    });
};
module.exports["RangeField"] = $041e11f907714e25$export$b322c47b2525bd34;

});

parcelRegister("g50oa", function(module, exports) {
module.exports = new URL("NoDynamicCards.7cd8fd7d.svg", import.meta.url).toString();

});

parcelRegister("mXxnT", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $1Whri = parcelRequire("1Whri");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $bfgIy = parcelRequire("bfgIy");


var $ghftu = parcelRequire("ghftu");


var $eXmBZ = parcelRequire("eXmBZ");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $3v7tz = parcelRequire("3v7tz");

const $25b8de51b5bda7c4$var$styles = {
    dropdownTrigger: "_18zrutpp _1rjc12x7 _syazazsu _bfhksm61 _irr31dpa",
    dropdownFullWidthStyles: "_1bsb1osq",
    border: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1",
    iconBackgroundStyles: "_2rkolb4i _bfhk7qp0 _1bsbzwfg _4t3izwfg _4cvr1h6o _1bah1h6o",
    dropdownTriggerInnerStyles: "_zulp1b66",
    dropdownTriggerTextStyles: "_16jlkb7n _1o9zidpf _i0dlf1ug _1reo15vq _18m915vq _1e0c1o8l _y3gn1e5h _1bto1l2s _o5721q9c",
    iconContainerStyles: "_1o9zidpf",
    selected: "_1h6d1w55 _syaz6x5g _bfhk15s3",
    fieldStyles: "_1bsb1osq"
};
const $25b8de51b5bda7c4$var$FieldWrapper = ({ useInline: useInline, children: children })=>useInline ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        spread: "space-between",
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        children: children
    });
const $25b8de51b5bda7c4$var$FieldDropdown = ({ id: id, isDisabled: isDisabled, onSelect: onSelect, selectedOption: selectedOption, showUpdatedStyles: showUpdatedStyles, options: options })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                ...props,
                id: id,
                isDisabled: isDisabled,
                ref: triggerRef,
                xcss: (0, $1Whri.cx)($25b8de51b5bda7c4$var$styles.dropdownTrigger, $25b8de51b5bda7c4$var$styles.border, !showUpdatedStyles && $25b8de51b5bda7c4$var$styles.dropdownFullWidthStyles, props.isSelected && $25b8de51b5bda7c4$var$styles.selected),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    xcss: (0, $1Whri.cx)($25b8de51b5bda7c4$var$styles.dropdownTriggerInnerStyles, props.isSelected && $25b8de51b5bda7c4$var$styles.selected),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            xcss: $25b8de51b5bda7c4$var$styles.dropdownTriggerTextStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "inherit",
                                weight: "medium",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...selectedOption.label
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $25b8de51b5bda7c4$var$styles.iconContainerStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                spacing: "none",
                                label: "",
                                size: "small"
                            })
                        })
                    ]
                })
            }),
        shouldFitContainer: !showUpdatedStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
            children: options.map((option)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                    isSelected: selectedOption.value === option.value,
                    ...option.icon && {
                        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            xcss: $25b8de51b5bda7c4$var$styles.iconBackgroundStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)(option.icon, {
                                label: `${option.value}-option-icon`,
                                color: "var(--ds-icon, #292A2E)"
                            })
                        })
                    },
                    ...option.description && {
                        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...option.description
                        })
                    },
                    onClick: ()=>onSelect(option),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...option.label
                    })
                }, `${option.value}-key`);
            })
        })
    });
const $25b8de51b5bda7c4$export$71e448abd02c1425 = ({ children: children, fieldType: fieldType, label: label, onSelect: onSelect, options: options, renderVariant: renderVariant, selectedOption: selectedOption, showUpdatedStyles: showUpdatedStyles = false, infoTooltip: infoTooltip, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    const handleSelect = (0, $42omo.useCallback)((selectedLabel)=>{
        onSelect(selectedLabel);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: `${fieldType}Dropdown`,
                source: source,
                attributes: {
                    renderVariant: renderVariant,
                    selectedValue: selectedLabel.value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        fieldType,
        onSelect,
        renderVariant,
        source
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        direction: "column",
        xcss: (0, $1Whri.cx)($25b8de51b5bda7c4$var$styles.fieldStyles),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                space: "space.200",
                children: /*#__PURE__*/ (0, $l998X.jsxs)($25b8de51b5bda7c4$var$FieldWrapper, {
                    useInline: showUpdatedStyles,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.100",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                                    htmlFor: `${fieldType}-dropdown`,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: showUpdatedStyles ? 'medium' : 'small',
                                        color: showUpdatedStyles ? 'color.text' : 'color.text.subtlest',
                                        weight: showUpdatedStyles ? 'regular' : 'bold',
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...label
                                        })
                                    })
                                }),
                                infoTooltip && /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                    content: infoTooltip,
                                    position: "bottom",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                                        testId: "info-icon",
                                        label: infoTooltip,
                                        color: "var(--ds-icon-discovery, #AF59E1)"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)($25b8de51b5bda7c4$var$FieldDropdown, {
                            id: `${fieldType}-dropdown`,
                            isDisabled: isDisabled,
                            onSelect: handleSelect,
                            selectedOption: selectedOption,
                            showUpdatedStyles: showUpdatedStyles,
                            options: options
                        })
                    ]
                })
            }),
            children
        ]
    });
};
module.exports["ConfigFieldDropdown"] = $25b8de51b5bda7c4$export$71e448abd02c1425;

});

parcelRegister("cL1OY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1Whri = parcelRequire("1Whri");


var $dxgIg = parcelRequire("dxgIg");


var $1dusJ = parcelRequire("1dusJ");


var $9Y9Mx = parcelRequire("9Y9Mx");


var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $3v7tz = parcelRequire("3v7tz");


var $4cOi8 = parcelRequire("4cOi8");


var $cgtv4 = parcelRequire("cgtv4");

const $4d728949552c1ea4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    leftAlignmentLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2.left",
        defaultMessage: "Left"
    },
    centerAlignmentLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2.center",
        defaultMessage: "Center"
    },
    rightAlignmentLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2.right",
        defaultMessage: "Right"
    },
    alignmentLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2",
        defaultMessage: "Alignment"
    }
});


const $eddefd77aa4ccbd1$var$styles = {
    borderOptionContainer: "_1rjcv77o _18zr1b66 _bfhkysee",
    border: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1",
    selected: "_1h6d1w55 _bfhk15s3 _syaz6x5g"
};
const $eddefd77aa4ccbd1$var$alignmentOptions = [
    {
        label: (0, $4d728949552c1ea4$export$defe85febe8b728c).leftAlignmentLabel,
        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($1dusJ))),
        value: (0, $4cOi8.Alignment).LEFT
    },
    {
        label: (0, $4d728949552c1ea4$export$defe85febe8b728c).centerAlignmentLabel,
        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($dxgIg))),
        value: (0, $4cOi8.Alignment).CENTER
    },
    {
        label: (0, $4d728949552c1ea4$export$defe85febe8b728c).rightAlignmentLabel,
        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($9Y9Mx))),
        value: (0, $4cOi8.Alignment).RIGHT
    }
];
const $eddefd77aa4ccbd1$export$8c99ded85c285ba = ({ selectedAlignment: selectedAlignment, updateMainFormField: updateMainFormField, renderVariant: renderVariant, source: source })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    const handleSelect = (0, $42omo.useCallback)((newValue)=>{
        updateMainFormField({
            alignment: newValue
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'buttonGroup',
                actionSubjectId: 'alignment',
                source: source,
                attributes: {
                    renderVariant: renderVariant,
                    selectedValue: newValue
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        createAnalyticsEvent,
        renderVariant,
        source
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        spread: "space-between",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $4d728949552c1ea4$export$defe85febe8b728c).alignmentLabel
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                space: "space.075",
                children: $eddefd77aa4ccbd1$var$alignmentOptions.map(({ label: label, IconComponent: IconComponent, value: value })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...label
                        }),
                        hideTooltipOnMouseDown: true,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                            xcss: (0, $1Whri.cx)($eddefd77aa4ccbd1$var$styles.borderOptionContainer, $eddefd77aa4ccbd1$var$styles.border, value === selectedAlignment && $eddefd77aa4ccbd1$var$styles.selected),
                            onClick: ()=>handleSelect(value),
                            isDisabled: isDisabled,
                            children: /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                                color: value === selectedAlignment ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
                                label: formatMessage(label)
                            })
                        })
                    }, value))
            })
        ]
    });
};
module.exports["AlignmentField"] = $eddefd77aa4ccbd1$export$8c99ded85c285ba;

});


//# sourceMappingURL=cards-extension.74a35849.js.map
